/* enm-v2-canvas.js — EnM V2 interactive canvas.
   Loaded as a regular asset (not {% javascript %}) per L23.
   All Liquid data lives in window._ENM_V2_PRODUCT (set by the section's HTML script block).
*/
(function () {
  'use strict';

  var canvas = document.getElementById('enm-v2-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');

  // ── Product + limits from Liquid globals ──────────────────────────────────
  var _product = window._ENM_V2_PRODUCT || {};
  var collection = _product.collection || new URLSearchParams(window.location.search).get('collection') || 'custom-rectangular-nameplates';
  var productType =
    collection === 'unique-shape-nameplates' ? 'shaped' :
    collection === 'name-badges' ? 'badge' :
    collection === 'industrial-tags' ? 'industrial' :
    collection === 'memorial-recognition-nameplates' ? 'memorial' :
    'rectangular';

  var _plateLimits = (function () {
    try { return JSON.parse((document.getElementById('enm-plate-limits') || {}).textContent || '{}'); }
    catch (e) { return {}; }
  })();
  function _getLimit(map, fallback, value) {
    var keys = Object.keys(map).map(Number).sort(function (a, b) { return a - b; });
    for (var i = 0; i < keys.length; i++) { if (value <= keys[i]) return map[String(keys[i])]; }
    return fallback;
  }

  // ── Constants ─────────────────────────────────────────────────────────────
  var PPI = 150;           // logical px per inch (fixed — no zoom control in V2)
  var DPR = window.devicePixelRatio || 1;
  var Z   = PPI / 72;     // scale factor vs V1 (which uses PPI=72 at zoom=1)
  var HANDLE_H = 8;       // handle half-size in logical px

  var FONTS = [
    { name: 'Arial',               family: 'Arial, sans-serif' },
    { name: 'Verdana',             family: 'Verdana, sans-serif' },
    { name: 'Georgia',             family: 'Georgia, serif' },
    { name: 'Times New Roman',     family: "'Times New Roman', serif" },
    { name: 'Dancing Script',      family: "'Dancing Script', cursive" },
    { name: 'Indie Flower',        family: "'Indie Flower', cursive" },
    { name: 'Pinyon Script',       family: "'Pinyon Script', cursive" },
    { name: 'Cinzel',               family: "'Cinzel', serif" },
    { name: 'Courier New',         family: "'Courier New', monospace" },
    { name: 'Courier Prime',       family: "'Courier Prime', monospace" },
    { name: 'Lato',                family: "'Lato', sans-serif" },
    { name: 'Oswald',              family: "'Oswald', sans-serif" },
    // { name: 'Merriweather',        family: "'Merriweather', serif" },
    { name: 'Anton',               family: "'Anton', sans-serif" },
    { name: 'Cantata One',         family: "'Cantata One', cursive" },
    { name: 'Alegreya',            family: "'Alegreya', serif" },
    { name: 'Archivo Black',       family: "'Archivo Black', sans-serif" },
    { name: 'EB Garamond',         family: "'EB Garamond', serif" },
    { name: 'Homemade Apple',      family: "'Homemade Apple', cursive" },
    { name: 'Graduate',            family: "'Graduate', cursive" },
    { name: 'Libre Baskerville',   family: "'Libre Baskerville', serif" }
  ];

  var metalBg = {
    'satin-brass':         '#E1C16E',
    'polished-brass':      '#E1C16E',
    'satin-silver':        '#C0C0C0',
    'polished-silver':     '#C0C0C0',
    'satin-copper':        '#a75e4a',
    'black-colored-brass': '#121212',
    'maroon-brass':        '#640f24',
    'black-aluminum':      '#1A1B1C',
    'black-brass':         '#121212'
  };
  var metalFg = {
    'satin-brass':         '#1A1A1A',
    'polished-brass':      '#1A1A1A',
    'satin-silver':        '#1A1A1A',
    'polished-silver':     '#1A1A1A',
    'satin-copper':        '#1A1A1A',
    'black-colored-brass': '#D4AF37',
    'maroon-brass':        '#D4AF37',
    'black-aluminum':      '#E0E0E0',
    'black-brass':         '#D4AF37'
  };
  var oppositeGridColor = {
    'satin-brass':         'rgba(44,82,130,0.35)',
    'polished-brass':      'rgba(44,82,130,0.35)',
    'satin-silver':        'rgba(74,85,104,0.35)',
    'polished-silver':     'rgba(74,85,104,0.35)',
    'satin-copper':        'rgba(74,143,167,0.35)',
    'black-colored-brass': 'rgba(229,231,235,0.45)',
    'maroon-brass':        'rgba(149,213,232,0.45)',
    'black-aluminum':      'rgba(229,231,235,0.45)',
    'black-brass':         'rgba(229,231,235,0.45)'
  };
  var METAL_FINISH_OPTIONS = [
    { slug: 'satin-brass',         label: 'Satin Brass' },
    { slug: 'polished-brass',      label: 'Polished Brass' },
    { slug: 'satin-silver',        label: 'Satin Silver' },
    { slug: 'polished-silver',     label: 'Polished Silver' },
    { slug: 'satin-copper',        label: 'Satin Copper' },
    { slug: 'black-colored-brass', label: 'Black-colored Brass' },
    { slug: 'maroon-brass',        label: 'Maroon Brass' },
    { slug: 'black-aluminum',      label: 'Black Aluminum' }
  ];
  var PLATE_SHAPES = {
    oval: function (ctx, w, h) {
      ctx.beginPath();
      ctx.ellipse(w / 2, h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
    },
    heart: function (ctx, w, h) {
      var x = w / 2, y = h * 0.52;
      ctx.beginPath();
      ctx.moveTo(x, y + h * 0.35);
      ctx.bezierCurveTo(x, y, x - w * 0.55, y, x - w * 0.35, y - h * 0.3);
      ctx.bezierCurveTo(x - w * 0.1, y - h * 0.55, x, y - h * 0.38, x, y - h * 0.15);
      ctx.bezierCurveTo(x, y - h * 0.38, x + w * 0.1, y - h * 0.55, x + w * 0.35, y - h * 0.3);
      ctx.bezierCurveTo(x + w * 0.55, y, x, y, x, y + h * 0.35);
      ctx.closePath();
    },
    leaf: function (ctx, w, h) {
      ctx.beginPath();
      ctx.moveTo(w / 2, 0);
      ctx.bezierCurveTo(w * 0.9, h * 0.25, w * 0.9, h * 0.75, w / 2, h);
      ctx.bezierCurveTo(w * 0.1, h * 0.75, w * 0.1, h * 0.25, w / 2, 0);
      ctx.closePath();
    },
    'leaf-wide': function (ctx, w, h) {
      ctx.beginPath();
      ctx.moveTo(w / 2, 0);
      ctx.bezierCurveTo(w, h * 0.2, w, h * 0.7, w / 2, h);
      ctx.bezierCurveTo(0, h * 0.7, 0, h * 0.2, w / 2, 0);
      ctx.closePath();
    },
    'leaf-long': function (ctx, w, h) {
      ctx.beginPath();
      ctx.moveTo(w / 2, 0);
      ctx.bezierCurveTo(w * 0.75, h * 0.3, w * 0.75, h * 0.7, w / 2, h);
      ctx.bezierCurveTo(w * 0.25, h * 0.7, w * 0.25, h * 0.3, w / 2, 0);
      ctx.closePath();
    }
  };
  var MOUNT_DISPLAY_TO_SLUG = {
    'none': 'none', 'adhesive': 'adhesive',
    '2 holes w/ screws': '2-side-holes', '4 holes w/ screws': '4-corner-holes',
    '2 holes': '2-side-holes', '4 holes': '4-corner-holes',
    '2 holes w/ rivets': 'rivet', '4 holes w/ rivets': 'rivet-4',
    'rivet (2-hole)': 'rivet', 'rivet (4-hole)': 'rivet-4'
  };

  // ── State ─────────────────────────────────────────────────────────────────
  var spec = {
    type: productType,
    width: parseFloat(_product.plateWidth) || 3,
    height: parseFloat(_product.plateHeight) || 1,
    metal: metalLabelToSlug(_product.defaultMetal) || 'satin-brass',
    corner: _product.defaultCorner || 'square',
    shape: 'rectangle',
    shapeSvg: '',
    mounting: _product.defaultMounting ? (mountDisplayToSlug(_product.defaultMounting) || _product.defaultMounting) : 'none',
    borderPng: _product.borderPng || '',
    borderMargin: parseFloat(_product.borderMargin) || 0
  };
  var layers = [];       // [{id, type:'text'|'clipart', ...}]
  var activeLayerId = null;
  var nextLayerId = 1;
  var _capturingClean = false;
  var _editLineItemKey = '';
    var _editVariantId = null;
    // Helper to get URL param
    function getUrlParam(name) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(window.location.href);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    // On load, capture edit line item key and variant id from URL
    (function() {
      var key = getUrlParam('line_item_key');
      if (key) _editLineItemKey = key;
      var vId = getUrlParam('variant_id');
      if (vId) _editVariantId = parseInt(vId, 10);
    })();
  var _metalIsVariant = false;
  var _cornerFromProduct = false;
  var _selections = {};  // optionIndex → selected value string
  var _suppressVariantChange = false; // prevent listener re-init during programmatic sync
  var _textLineCountOverride = parseInt(_product.textLineNo, 10) || 0;
  var _showGrid = true;
  var _snapGuideX = null;
  var _snapGuideY = null;
  var GRID_PREF_KEY = '_enm_v2_industrial_show_grid';
  var _multiSelectMode = false;
  var _selectedLayerIds = {};

  function resolveTextLineCountOverride(variant) {
    var variantCount = variant ? parseInt(variant.textLineNo, 10) : 0;
    if (variantCount > 0) return variantCount;
    var productCount = parseInt(_product.textLineNo, 10) || 0;
    return productCount > 0 ? productCount : 0;
  }
  var _tagTemplates = Array.isArray(_product.tagTemplates) ? _product.tagTemplates : [];
  var _currentTemplateId = '';

  function getGridStepIn() {
    if (spec.height <= 0.5) return 0.2;
    if (spec.height <= 2) return 0.25;
    return 0.5;
  }

  function getSnapPreviewThresholdPx() {
    var stepPx = getGridStepIn() * PPI;
    return Math.max(2, Math.min(4, Math.round(stepPx * 0.08)));
  }

  function loadGridPreference() {
    try {
      var saved = sessionStorage.getItem(GRID_PREF_KEY);
      if (saved === '0' || saved === 'false') _showGrid = false;
      if (saved === '1' || saved === 'true') _showGrid = true;
    } catch (e) {}
  }

  function saveGridPreference() {
    try { sessionStorage.setItem(GRID_PREF_KEY, _showGrid ? '1' : '0'); } catch (e) {}
  }

  function syncGridToggleUI() {
    var gridToggleEl = document.getElementById('enm-v2-grid-toggle');
    if (gridToggleEl) gridToggleEl.setAttribute('aria-pressed', _showGrid ? 'true' : 'false');
  }

  function initCanvasHints() {
    var hintEl = document.getElementById('enm-v2-canvas-hint');
    if (!hintEl) return;
    var hints = [
      'Tip: Shift+click to select multiple layers.',
      'Tip: Drag the blue corner handle to resize selected layers.',
      'Tip: Use Snap buttons to align left/center/right or top/middle/bottom.',
      'Tip: Turn on Grid to place text and icons precisely.',
      'Tip: Drag a layer near grid lines to preview snap guides.'
    ];
    var i = 0;
    hintEl.textContent = hints[i];
    if (hints.length < 2) return;
    setInterval(function () {
      i = (i + 1) % hints.length;
      hintEl.textContent = hints[i];
    }, 4200);
  }

  loadGridPreference();

  var CODE_FORMATS_1D = ['CODE128', 'CODE93'];
  var CODE_FORMATS_2D = ['qrcode', 'datamatrix'];
  var BCID_MAP = {
    CODE128: 'code128',
    CODE93: 'code93',
    CODE39: 'code39',
    qrcode: 'qrcode',
    datamatrix: 'datamatrix'
  };

  function isCodeLayer(layer) {
    return !!layer && (layer.type === 'barcode-1d' || layer.type === 'barcode-2d');
  }

  function getTemplateById(id) {
    return _tagTemplates.find(function (t) { return t.id === id; }) || null;
  }

  function getTextLayers() {
    return layers.filter(function (l) { return l.type === 'text'; }).sort(function (a, b) {
      var ai = a._lineIndex == null ? 999 : a._lineIndex;
      var bi = b._lineIndex == null ? 999 : b._lineIndex;
      return ai - bi;
    });
  }

  function maxLines()    { return _textLineCountOverride > 0 ? _textLineCountOverride : _getLimit(_plateLimits.heights || {}, _plateLimits.heightMax || 10, spec.height); }
  function maxChars()    { return _getLimit(_plateLimits.widths  || {}, _plateLimits.widthMax  || 65, spec.width); }
  function maxCliparts() { return _plateLimits.maxCliparts || 6; }

  // ── Canvas geometry ───────────────────────────────────────────────────────
  function pw() { return spec.width  * PPI; }
  function ph() { return spec.height * PPI; }

  function resizeCanvas() {
    var W = pw(), H = ph();
    var wrap = canvas.parentElement;
    var maxW = wrap ? Math.max(120, wrap.clientWidth - 64) : 600;
    var viewportH = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var maxH = isMobile ? Math.max(120, Math.floor(viewportH * 0.25)) : 480;
    var fitScale = Math.min(1, maxW / W, maxH / H);
    canvas.width  = Math.round(W * DPR);
    canvas.height = Math.round(H * DPR);
    canvas.style.width  = Math.round(W * fitScale) + 'px';
    canvas.style.height = Math.round(H * fitScale) + 'px';
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(DPR, DPR);
    renderCanvas();
  }

  function getCanvasPoint(clientX, clientY) {
    var rect = canvas.getBoundingClientRect();
    var scaleX = canvas.width  / DPR / rect.width;
    var scaleY = canvas.height / DPR / rect.height;
    return { px: (clientX - rect.left) * scaleX, py: (clientY - rect.top) * scaleY };
  }

  // ── SVG path processing (full port from V1 — handles M/L/C/S/Q/T/A/Z) ────
  function svgPathProcess(d, mode, W, H, bb) {
    var tokens = d.trim().split(/(?=[MmLlHhVvCcSsQqTtAaZz])/);
    var cx = 0, cy = 0, sx = 0, sy = 0;
    var lastCmd = '', lcpx = 0, lcpy = 0, lqpx = 0, lqpy = 0;
    var xs, ys, scaleX, scaleY, tx, ty;
    if (mode === 'bbox') { xs = []; ys = []; }
    else { scaleX = W / bb.width; scaleY = H / bb.height; tx = -bb.x * scaleX; ty = -bb.y * scaleY; }
    function pxx(x) { return x * scaleX + tx; }
    function pyy(y) { return y * scaleY + ty; }
    function arcToCubics(ax1, ay1, arx, ary, xRotDeg, largeArc, sweep, ax2, ay2) {
      var PI = Math.PI, rad = xRotDeg * PI / 180;
      var cosR = Math.cos(rad), sinR = Math.sin(rad);
      arx = Math.abs(arx); ary = Math.abs(ary);
      if (!arx || !ary) return [[ax1, ay1, ax2, ay2, ax2, ay2]];
      var dx2 = (ax1 - ax2) / 2, dy2 = (ay1 - ay2) / 2;
      var x1p = cosR * dx2 + sinR * dy2, y1p = -sinR * dx2 + cosR * dy2;
      var x1p2 = x1p*x1p, y1p2 = y1p*y1p, rx2 = arx*arx, ry2 = ary*ary;
      var lam = x1p2/rx2 + y1p2/ry2;
      if (lam > 1) { var ls = Math.sqrt(lam); arx *= ls; ary *= ls; rx2 = arx*arx; ry2 = ary*ary; }
      var numer = rx2*ry2 - rx2*y1p2 - ry2*x1p2, denom = rx2*y1p2 + ry2*x1p2;
      var sq = Math.sqrt(Math.max(0, numer / denom));
      if (largeArc === sweep) sq = -sq;
      var cxp = sq*arx*y1p/ary, cyp = -sq*ary*x1p/arx;
      var acx = cosR*cxp - sinR*cyp + (ax1+ax2)/2, acy = sinR*cxp + cosR*cyp + (ay1+ay2)/2;
      function vAng(ux,uy,vx,vy) {
        var nn = Math.sqrt(ux*ux+uy*uy)*Math.sqrt(vx*vx+vy*vy);
        var aa = Math.acos(Math.max(-1,Math.min(1,(ux*vx+uy*vy)/nn)));
        return ux*vy - uy*vx < 0 ? -aa : aa;
      }
      var t1 = vAng(1,0,(x1p-cxp)/arx,(y1p-cyp)/ary);
      var dT = vAng((x1p-cxp)/arx,(y1p-cyp)/ary,(-x1p-cxp)/arx,(-y1p-cyp)/ary);
      if (!sweep && dT > 0) dT -= 2*PI; if (sweep && dT < 0) dT += 2*PI;
      var nSeg = Math.max(1, Math.ceil(Math.abs(dT)/(PI/2)));
      var dTi = dT/nSeg, result = [];
      var alp = (Math.sin(dTi)*(Math.sqrt(4+3*Math.pow(Math.tan(dTi/2),2))-1))/3;
      var t = t1;
      var ex0 = cosR*arx*Math.cos(t)-sinR*ary*Math.sin(t)+acx;
      var ey0 = sinR*arx*Math.cos(t)+cosR*ary*Math.sin(t)+acy;
      var edx0 = -cosR*arx*Math.sin(t)-sinR*ary*Math.cos(t);
      var edy0 = -sinR*arx*Math.sin(t)+cosR*ary*Math.cos(t);
      for (var si = 0; si < nSeg; si++) {
        var t2 = t+dTi;
        var ex1 = cosR*arx*Math.cos(t2)-sinR*ary*Math.sin(t2)+acx;
        var ey1 = sinR*arx*Math.cos(t2)+cosR*ary*Math.sin(t2)+acy;
        var edx1 = -cosR*arx*Math.sin(t2)-sinR*ary*Math.cos(t2);
        var edy1 = -sinR*arx*Math.sin(t2)+cosR*ary*Math.cos(t2);
        result.push([ex0+alp*edx0, ey0+alp*edy0, ex1-alp*edx1, ey1-alp*edy1, ex1, ey1]);
        t=t2; ex0=ex1; ey0=ey1; edx0=edx1; edy0=edy1;
      }
      return result;
    }
    tokens.forEach(function (tok) {
      tok = tok.trim(); if (!tok) return;
      var cmd = tok[0];
      var nums = tok.slice(1).trim().split(/[\s,]+/).filter(Boolean).map(Number);
      var i = 0;
      function n() { var v = nums[i++]; return (v === undefined || isNaN(v)) ? 0 : v; }
      switch (cmd) {
        case 'M': cx=n(); cy=n(); sx=cx; sy=cy;
          if (mode==='bbox'){xs.push(cx);ys.push(cy);}else ctx.moveTo(pxx(cx),pyy(cy));
          while(i<nums.length){cx=n();cy=n();if(mode==='bbox'){xs.push(cx);ys.push(cy);}else ctx.lineTo(pxx(cx),pyy(cy));} break;
        case 'm': cx+=n(); cy+=n(); sx=cx; sy=cy;
          if (mode==='bbox'){xs.push(cx);ys.push(cy);}else ctx.moveTo(pxx(cx),pyy(cy));
          while(i<nums.length){cx+=n();cy+=n();if(mode==='bbox'){xs.push(cx);ys.push(cy);}else ctx.lineTo(pxx(cx),pyy(cy));} break;
        case 'L': while(i<nums.length){cx=n();cy=n();if(mode==='bbox'){xs.push(cx);ys.push(cy);}else ctx.lineTo(pxx(cx),pyy(cy));} break;
        case 'l': while(i<nums.length){cx+=n();cy+=n();if(mode==='bbox'){xs.push(cx);ys.push(cy);}else ctx.lineTo(pxx(cx),pyy(cy));} break;
        case 'H': while(i<nums.length){cx=n();if(mode==='bbox')xs.push(cx);else ctx.lineTo(pxx(cx),pyy(cy));} break;
        case 'h': while(i<nums.length){cx+=n();if(mode==='bbox')xs.push(cx);else ctx.lineTo(pxx(cx),pyy(cy));} break;
        case 'V': while(i<nums.length){cy=n();if(mode==='bbox')ys.push(cy);else ctx.lineTo(pxx(cx),pyy(cy));} break;
        case 'v': while(i<nums.length){cy+=n();if(mode==='bbox')ys.push(cy);else ctx.lineTo(pxx(cx),pyy(cy));} break;
        case 'C':
          while(i<nums.length){var c1x=n(),c1y=n(),c2x=n(),c2y=n(),ex=n(),ey=n();lcpx=c2x;lcpy=c2y;cx=ex;cy=ey;
            if(mode==='bbox'){xs.push(c1x,c2x,cx);ys.push(c1y,c2y,cy);}else ctx.bezierCurveTo(pxx(c1x),pyy(c1y),pxx(c2x),pyy(c2y),pxx(cx),pyy(cy));} break;
        case 'c':
          while(i<nums.length){var dc1x=n(),dc1y=n(),dc2x=n(),dc2y=n(),dex=n(),dey=n();
            lcpx=cx+dc2x;lcpy=cy+dc2y;if(mode==='bbox'){xs.push(cx+dc1x,lcpx,cx+dex);ys.push(cy+dc1y,lcpy,cy+dey);}
            else ctx.bezierCurveTo(pxx(cx+dc1x),pyy(cy+dc1y),pxx(lcpx),pyy(lcpy),pxx(cx+dex),pyy(cy+dey));cx+=dex;cy+=dey;} break;
        case 'S':
          while(i<nums.length){var Sc2x=n(),Sc2y=n(),Sex=n(),Sey=n();
            var Sc1x=/[CcSs]/.test(lastCmd)?2*cx-lcpx:cx,Sc1y=/[CcSs]/.test(lastCmd)?2*cy-lcpy:cy;
            lcpx=Sc2x;lcpy=Sc2y;if(mode==='bbox'){xs.push(Sc1x,Sc2x,Sex);ys.push(Sc1y,Sc2y,Sey);}
            else ctx.bezierCurveTo(pxx(Sc1x),pyy(Sc1y),pxx(Sc2x),pyy(Sc2y),pxx(Sex),pyy(Sey));cx=Sex;cy=Sey;} break;
        case 's':
          while(i<nums.length){var sdc2x=n(),sdc2y=n(),sdex=n(),sdey=n();
            var sc1x=/[CcSs]/.test(lastCmd)?2*cx-lcpx:cx,sc1y=/[CcSs]/.test(lastCmd)?2*cy-lcpy:cy;
            lcpx=cx+sdc2x;lcpy=cy+sdc2y;if(mode==='bbox'){xs.push(sc1x,lcpx,cx+sdex);ys.push(sc1y,lcpy,cy+sdey);}
            else ctx.bezierCurveTo(pxx(sc1x),pyy(sc1y),pxx(lcpx),pyy(lcpy),pxx(cx+sdex),pyy(cy+sdey));cx+=sdex;cy+=sdey;} break;
        case 'Q':
          while(i<nums.length){var Qqx=n(),Qqy=n(),Qex=n(),Qey=n();lqpx=Qqx;lqpy=Qqy;
            var Qcp1x=cx+(2/3)*(Qqx-cx),Qcp1y=cy+(2/3)*(Qqy-cy),Qcp2x=Qex+(2/3)*(Qqx-Qex),Qcp2y=Qey+(2/3)*(Qqy-Qey);lcpx=Qcp2x;lcpy=Qcp2y;cx=Qex;cy=Qey;
            if(mode==='bbox'){xs.push(Qqx,cx);ys.push(Qqy,cy);}else ctx.bezierCurveTo(pxx(Qcp1x),pyy(Qcp1y),pxx(Qcp2x),pyy(Qcp2y),pxx(cx),pyy(cy));} break;
        case 'q':
          while(i<nums.length){var qdx1=n(),qdy1=n(),qdx=n(),qdy=n();lqpx=cx+qdx1;lqpy=cy+qdy1;
            var qcp1x=cx+(2/3)*qdx1,qcp1y=cy+(2/3)*qdy1,qcp2x=cx+qdx+(2/3)*(qdx1-qdx),qcp2y=cy+qdy+(2/3)*(qdy1-qdy);
            lcpx=qcp2x;lcpy=qcp2y;if(mode==='bbox'){xs.push(cx+qdx1,cx+qdx);ys.push(cy+qdy1,cy+qdy);}
            else ctx.bezierCurveTo(pxx(qcp1x),pyy(qcp1y),pxx(qcp2x),pyy(qcp2y),pxx(cx+qdx),pyy(cy+qdy));cx+=qdx;cy+=qdy;} break;
        case 'T':
          while(i<nums.length){var Tqx=/[QqTt]/.test(lastCmd)?2*cx-lqpx:cx,Tqy=/[QqTt]/.test(lastCmd)?2*cy-lqpy:cy;
            var Tex=n(),Tey=n();lqpx=Tqx;lqpy=Tqy;
            var Tcp1x=cx+(2/3)*(Tqx-cx),Tcp1y=cy+(2/3)*(Tqy-cy),Tcp2x=Tex+(2/3)*(Tqx-Tex),Tcp2y=Tey+(2/3)*(Tqy-Tey);
            lcpx=Tcp2x;lcpy=Tcp2y;cx=Tex;cy=Tey;
            if(mode==='bbox'){xs.push(Tqx,cx);ys.push(Tqy,cy);}else ctx.bezierCurveTo(pxx(Tcp1x),pyy(Tcp1y),pxx(Tcp2x),pyy(Tcp2y),pxx(cx),pyy(cy));} break;
        case 't':
          while(i<nums.length){var tqx=/[QqTt]/.test(lastCmd)?2*cx-lqpx:cx,tqy=/[QqTt]/.test(lastCmd)?2*cy-lqpy:cy;
            var tdx=n(),tdy=n();lqpx=tqx;lqpy=tqy;
            var tcp1x=cx+(2/3)*(tqx-cx),tcp1y=cy+(2/3)*(tqy-cy),tcp2x=cx+tdx+(2/3)*(tqx-(cx+tdx)),tcp2y=cy+tdy+(2/3)*(tqy-(cy+tdy));
            lcpx=tcp2x;lcpy=tcp2y;if(mode==='bbox'){xs.push(tqx,cx+tdx);ys.push(tqy,cy+tdy);}
            else ctx.bezierCurveTo(pxx(tcp1x),pyy(tcp1y),pxx(tcp2x),pyy(tcp2y),pxx(cx+tdx),pyy(cy+tdy));cx+=tdx;cy+=tdy;} break;
        case 'A':
          while(i<nums.length){var Arx=n(),Ary=n(),ARot=n(),ALg=n(),ASw=n(),Aex=n(),Aey=n();
            arcToCubics(cx,cy,Arx,Ary,ARot,ALg,ASw,Aex,Aey).forEach(function(s){lcpx=s[2];lcpy=s[3];cx=s[4];cy=s[5];
              if(mode==='bbox'){xs.push(s[0],s[2],s[4]);ys.push(s[1],s[3],s[5]);}else ctx.bezierCurveTo(pxx(s[0]),pyy(s[1]),pxx(s[2]),pyy(s[3]),pxx(s[4]),pyy(s[5]));});} break;
        case 'a':
          while(i<nums.length){var arx=n(),ary=n(),aRot=n(),aLg=n(),aSw=n(),adx=n(),ady=n();
            arcToCubics(cx,cy,arx,ary,aRot,aLg,aSw,cx+adx,cy+ady).forEach(function(s){lcpx=s[2];lcpy=s[3];cx=s[4];cy=s[5];
              if(mode==='bbox'){xs.push(s[0],s[2],s[4]);ys.push(s[1],s[3],s[5]);}else ctx.bezierCurveTo(pxx(s[0]),pyy(s[1]),pxx(s[2]),pyy(s[3]),pxx(s[4]),pyy(s[5]));});} break;
        case 'Z': case 'z': cx=sx; cy=sy; if(mode==='draw') ctx.closePath(); break;
      }
      lastCmd = cmd;
    });
    if (mode === 'bbox') {
      if (!xs.length) return null;
      var minX=Math.min.apply(null,xs), minY=Math.min.apply(null,ys);
      return { x:minX, y:minY, width:Math.max.apply(null,xs)-minX, height:Math.max.apply(null,ys)-minY };
    }
  }

  // ── Plate path ────────────────────────────────────────────────────────────
  function buildPlatePath(W, H) {
    ctx.beginPath();
    var shape = spec.shape || '';
    if (spec.shapeSvg) {
      try {
        var bb = svgPathProcess(spec.shapeSvg, 'bbox');
        if (!bb || bb.width === 0 || bb.height === 0) { ctx.rect(0,0,W,H); return; }
        svgPathProcess(spec.shapeSvg, 'draw', W, H, bb);
      } catch(e) { ctx.rect(0,0,W,H); }
      return;
    }
    if (!shape || shape === 'rectangle') {
      switch (spec.corner) {
        case 'rounded': ctx.roundRect(0,0,W,H, spec.height<=0.5 ? 9*Z : 13.5*Z); break;
        case 'notched': {
          var nn = 13.5*Z;
          ctx.moveTo(nn,0); ctx.lineTo(W-nn,0); ctx.arc(W,0,nn,Math.PI,Math.PI/2,true);
          ctx.lineTo(W,H-nn); ctx.arc(W,H,nn,3*Math.PI/2,Math.PI,true);
          ctx.lineTo(nn,H); ctx.arc(0,H,nn,0,3*Math.PI/2,true);
          ctx.lineTo(0,nn); ctx.arc(0,0,nn,Math.PI/2,0,true); ctx.closePath(); break;
        }
        case 'chamfer': {
          var cc = 14.4*Z;
          ctx.moveTo(cc,0); ctx.lineTo(W-cc,0); ctx.lineTo(W,cc); ctx.lineTo(W,H-cc);
          ctx.lineTo(W-cc,H); ctx.lineTo(cc,H); ctx.lineTo(0,H-cc); ctx.lineTo(0,cc); ctx.closePath(); break;
        }
        case 'scallop': {
          var ss=18*Z, hh=ss, rr=14*Z, aa=4*Z;
          ctx.moveTo(ss,0); ctx.lineTo(W-ss,0); ctx.lineTo(W-ss,aa); ctx.arc(W-hh,hh,rr,3*Math.PI/2,0,false);
          ctx.lineTo(W,ss); ctx.lineTo(W,H-ss); ctx.lineTo(W-aa,H-ss); ctx.arc(W-hh,H-hh,rr,0,Math.PI/2,false);
          ctx.lineTo(W-ss,H); ctx.lineTo(ss,H); ctx.lineTo(ss,H-aa); ctx.arc(hh,H-hh,rr,Math.PI/2,Math.PI,false);
          ctx.lineTo(0,H-ss); ctx.lineTo(0,ss); ctx.lineTo(aa,ss); ctx.arc(hh,hh,rr,Math.PI,3*Math.PI/2,false); ctx.closePath(); break;
        }
        default: ctx.rect(0,0,W,H);
      }
      return;
    }
    if (PLATE_SHAPES[shape]) { PLATE_SHAPES[shape](ctx, W, H); return; }
    ctx.rect(0,0,W,H);
  }

  // ── Metal texture ─────────────────────────────────────────────────────────
  function renderMetalTexture(W, H) {
    var m = spec.metal;
    if (m==='satin-brass'||m==='satin-silver'||m==='satin-copper') {
      var seed = Math.round(W*1000+H*37);
      function rng() { seed=(seed*9301+49297)%233280; return seed/233280; }
      ctx.strokeStyle='#ffffff'; ctx.lineWidth=1;
      var y=0;
      while (y<H) {
        var a=0.025+rng()*0.085;
        if (rng()>0.12) { ctx.globalAlpha=a; ctx.beginPath(); ctx.moveTo(0,y); ctx.lineTo(W,y); ctx.stroke(); }
        y+=(0.7+rng()*2.1)*(PPI/72);
      }
      y=rng()*6*(PPI/72);
      while (y<H) {
        ctx.globalAlpha=0.06+rng()*0.12;
        ctx.beginPath(); ctx.moveTo((0.0+rng()*0.05)*W,y); ctx.lineTo(W-(0.35+rng()*0.65)*W,y);
        ctx.moveTo((0.7+rng()*0.85)*W,y); ctx.lineTo(W-(0.0+rng()*0.04)*W,y); ctx.stroke();
        y+=(5+rng()*10)*(PPI/72);
      }
      ctx.strokeStyle='#000000'; y=rng()*5*(PPI/72);
      while (y<H) {
        ctx.globalAlpha=0.04+rng()*0.07;
        ctx.beginPath(); ctx.moveTo((0.05+rng()*0.05)*W,y); ctx.lineTo(W-(0.55+rng()*0.65)*W,y);
        ctx.moveTo((0.7+rng()*0.75)*W,y); ctx.lineTo(W-(0.02+rng()*0.04)*W,y); ctx.stroke();
        y+=(4+rng()*10)*(PPI/72);
      }
      ctx.globalAlpha=1;
    } else if (m==='polished-brass'||m==='polished-silver') {
      var g=ctx.createLinearGradient(0,0,W*0.95,H*0.95);
      g.addColorStop(0,'rgba(255,255,255,0.72)'); g.addColorStop(0.18,'rgba(255,255,255,0.38)');
      g.addColorStop(0.42,'rgba(255,255,255,0.08)'); g.addColorStop(1,'rgba(255,255,255,0)');
      ctx.fillStyle=g; ctx.fillRect(0,0,W,H);
    }
  }

  // ── Decorative border layer (Memorial products) ─────────────────────────
  var _borderImg = null;
  var _borderImgUrl = '';

  function loadBorderImage(url, onLoad) {
    if (!url) { _borderImg = null; _borderImgUrl = ''; return; }
    if (url === _borderImgUrl && _borderImg) { if (onLoad) onLoad(); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      _borderImg = img;
      _borderImgUrl = url;
      if (onLoad) onLoad();
    };
    img.onerror = function () {
      console.warn('[EnM V2] Failed to load border PNG:', url);
    };
    img.src = url;
  }

  function renderBorderLayer(W, H) {
    if (!_borderImg) return;
    var m = (spec.borderMargin || 0) * PPI;
    var tw = W - 2 * m;
    var th = H - 2 * m;
    if (tw <= 0 || th <= 0) return;

    var off = document.createElement('canvas');
    off.width = Math.ceil(tw);
    off.height = Math.ceil(th);
    var oc = off.getContext('2d');
    oc.drawImage(_borderImg, 0, 0, tw, th);
    oc.globalCompositeOperation = 'source-in';
    oc.fillStyle = metalFg[spec.metal] || '#1A1A1A';
    oc.fillRect(0, 0, tw, th);

    ctx.drawImage(off, m, m);
  }

  // ── Mounting holes ────────────────────────────────────────────────────────
  var SCREW_COLOR_MAP = {
    'satin-brass':'gold','polished-brass':'gold','black-colored-brass':'gold','maroon-brass':'gold','black-brass':'gold',
    'satin-silver':'silver','polished-silver':'silver','black-aluminum':'silver','satin-copper':'black'
  };
  var SCREW_PALETTES = {
    gold:   {hi:'#E8C870',mid:'#C8943A',rim:'#987030',cross:'#6A4C18'},
    silver: {hi:'#E0E0E0',mid:'#B0B0B0',rim:'#808080',cross:'#505050'},
    black:  {hi:'#787878',mid:'#3C3C3C',rim:'#181818',cross:'#060606'}
  };
  function drawScrewHead(cx, cy, r, type) {
    var pal = SCREW_PALETTES[SCREW_COLOR_MAP[spec.metal]||'gold'];
    var grad = ctx.createRadialGradient(cx-r*0.3,cy-r*0.3,r*0.05,cx,cy,r);
    grad.addColorStop(0,pal.hi); grad.addColorStop(0.5,pal.mid); grad.addColorStop(1,pal.rim);
    ctx.beginPath(); ctx.arc(cx,cy,r,0,Math.PI*2); ctx.fillStyle=grad; ctx.fill();
    ctx.strokeStyle='rgba(0,0,0,0.25)'; ctx.lineWidth=0.5; ctx.stroke();
    ctx.save(); ctx.beginPath(); ctx.arc(cx,cy,r,0,Math.PI*2); ctx.clip();
    ctx.fillStyle=pal.cross;
    if (type === 'flat') {
      var sl = r * 0.82, sw = r * 0.28;
      ctx.fillRect(cx - sl, cy - sw/2, sl*2, sw);
    } else {
      var sw = r * 0.36, sl = r * 0.82;
      ctx.fillRect(cx - sl, cy - sw/2, sl*2, sw);
      ctx.fillRect(cx - sw/2, cy - sl, sw, sl*2);
    }
    ctx.restore();
  }

  function drawHole(cx, cy, r) {
    ctx.beginPath();
    ctx.arc(cx + Z * 0.8, cy + Z * 0.8, r, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(0,0,0,0.30)';
    ctx.fill();

    var grad = ctx.createRadialGradient(cx - r * 0.25, cy - r * 0.25, r * 0.05, cx, cy, r);
    grad.addColorStop(0, '#e8e8e8');
    grad.addColorStop(1, '#b0b0b0');
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.fillStyle = grad;
    ctx.fill();
    ctx.strokeStyle = 'rgba(0,0,0,0.25)';
    ctx.lineWidth = 0.8 * Z;
    ctx.stroke();
  }

  function drawRivetHole(cx, cy, r) {
    ctx.beginPath();
    ctx.arc(cx + Z, cy + Z, r + 1.5 * Z, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(0,0,0,0.22)';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.fillStyle = '#B4B4B4';
    ctx.fill();

    var domeGrad = ctx.createRadialGradient(cx - r * 0.38, cy - r * 0.38, r * 0.02, cx, cy, r);
    domeGrad.addColorStop(0, 'rgba(255,255,255,0.68)');
    domeGrad.addColorStop(0.22, 'rgba(255,255,255,0.28)');
    domeGrad.addColorStop(0.55, 'rgba(0,0,0,0.0)');
    domeGrad.addColorStop(1, 'rgba(0,0,0,0.42)');
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.fillStyle = domeGrad;
    ctx.fill();

    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.strokeStyle = 'rgba(0,0,0,0.30)';
    ctx.lineWidth = 0.8 * Z;
    ctx.stroke();

    var shoulderR = r * 0.52;
    var shoulderGrad = ctx.createRadialGradient(cx, cy, r * 0.22, cx, cy, shoulderR);
    shoulderGrad.addColorStop(0, 'rgba(0,0,0,0.35)');
    shoulderGrad.addColorStop(0.6, 'rgba(0,0,0,0.55)');
    shoulderGrad.addColorStop(1, 'rgba(0,0,0,0.70)');
    ctx.beginPath();
    ctx.arc(cx, cy, shoulderR, 0, Math.PI * 2);
    ctx.fillStyle = shoulderGrad;
    ctx.fill();

    var iRimGrad = ctx.createRadialGradient(cx - shoulderR * 0.35, cy - shoulderR * 0.35, 0, cx, cy, shoulderR);
    iRimGrad.addColorStop(0.72, 'rgba(255,255,255,0.0)');
    iRimGrad.addColorStop(0.88, 'rgba(255,255,255,0.18)');
    iRimGrad.addColorStop(1, 'rgba(255,255,255,0.0)');
    ctx.beginPath();
    ctx.arc(cx, cy, shoulderR, 0, Math.PI * 2);
    ctx.fillStyle = iRimGrad;
    ctx.fill();

    ctx.beginPath();
    ctx.arc(cx, cy, r * 0.27, 0, Math.PI * 2);
    ctx.fillStyle = '#1c1c1c';
    ctx.fill();
  }

  function renderHoles(W, H) {
    var hr = productType === 'industrial' ? 6 * Z : 4 * Z;
    var m = productType === 'industrial' ? 18 * Z : 11 * Z;
    var isLeaf = spec.shape === 'leaf' || spec.shape === 'leaf-wide' || spec.shape === 'leaf-long';
    var screwType = (spec.type !== 'shaped' || spec.height > 0.375) ? 'phillips' : 'flat';
    var cornerInset =
      spec.corner === 'notched' ? 6*Z :
      spec.corner === 'chamfer' ? 6*Z :
      spec.corner === 'scallop' ? 6*Z :
      0;
    m += cornerInset;
    function screw(x, y) { drawScrewHead(x, y, hr, screwType); }
    function drilled(x, y) {
      if (productType === 'industrial') drawHole(x, y, hr);
      else screw(x, y);
    }
    if (isLeaf) {
      var leafM = 18 * Z;
      switch (spec.mounting) {
        case '4-corner-holes':
        case '2-side-holes':
          drilled(leafM, H / 2);
          drilled(W - leafM, H / 2);
          break;
        case 'rivet':
          drawRivetHole(leafM, H / 2, hr);
          drawRivetHole(W - leafM, H / 2, hr);
          break;
      }
      return;
    }
    switch (spec.mounting) {
      case '4-corner-holes':
        drilled(m, m);
        drilled(W - m, m);
        drilled(m, H - m);
        drilled(W - m, H - m);
        break;
      case '2-side-holes':
        drilled(m, H / 2);
        drilled(W - m, H / 2);
        break;
      case 'rivet-4':
        drawRivetHole(m, m, hr);
        drawRivetHole(W - m, m, hr);
        drawRivetHole(m, H - m, hr);
        drawRivetHole(W - m, H - m, hr);
        break;
      case 'rivet':
        drawRivetHole(m, H / 2, hr);
        drawRivetHole(W - m, H / 2, hr);
        break;
    }
  }

  // ── Layer bounds ──────────────────────────────────────────────────────────
  function getLayerBounds(layer) {
    var W=pw(), H=ph();
    if (layer.type==='clipart') {
      var r=((layer.clipartSize||1)*PPI)/2;
      var cx=W/2+(layer.x||0)*PPI, cy=H/2+(layer.y||0)*PPI;
      var art=layer.clipartId?(window.ENM_CLIPARTS||{})[layer.clipartId]:null;
      var bb=art&&art.bbox?art.bbox:{x1:-1,y1:-1,x2:1,y2:1};
      return {x:cx+bb.x1*r,y:cy+bb.y1*r,w:(bb.x2-bb.x1)*r,h:(bb.y2-bb.y1)*r,cx:cx,cy:cy};
    }
    if (layer.type === 'barcode-1d') {
      var bw = (layer.width || 1.8) * PPI;
      var bh = (layer.height || 0.45) * PPI;
      var bcx = W / 2 + (layer.x || 0) * PPI;
      var bcy = H / 2 + (layer.y || 0) * PPI;
      return { x: bcx - bw / 2, y: bcy - bh / 2, w: bw, h: bh, cx: bcx, cy: bcy };
    }
    if (layer.type === 'barcode-2d') {
      var sz = (layer.size || 0.6) * PPI;
      var cx2 = W / 2 + (layer.x || 0) * PPI;
      var cy2 = H / 2 + (layer.y || 0) * PPI;
      return { x: cx2 - sz / 2, y: cy2 - sz / 2, w: sz, h: sz, cx: cx2, cy: cy2 };
    }
    var sz=layer.size||24;
    var fs=(layer.italic?'italic ':'')+(layer.bold?'bold ':'');
    ctx.save(); ctx.font=fs+sz+'px "'+(layer.font||'Arial')+'"'; ctx.textBaseline='middle';
    var mm=ctx.measureText(layer.text||'');
    var tw=mm.width;
    var th=mm.actualBoundingBoxAscent!=null&&mm.actualBoundingBoxDescent!=null
      ? mm.actualBoundingBoxAscent+mm.actualBoundingBoxDescent : sz;
    ctx.restore();
    var baseX=layer.align==='left'?W*0.05:layer.align==='right'?W*0.95:W/2;
    baseX+=(layer.x||0)*PPI;
    var centerY=H/2+(layer.y||0)*PPI;
    var x0=layer.align==='center'?baseX-tw/2:layer.align==='right'?baseX-tw:baseX;
    var tcx=x0+tw/2;
    var asc=mm.actualBoundingBoxAscent!=null?mm.actualBoundingBoxAscent:th*0.8;
    var desc=mm.actualBoundingBoxDescent!=null?mm.actualBoundingBoxDescent:th*0.2;
    var visualCy=centerY-(asc-desc)/2;
    return {x:tcx-tw/2,y:visualCy-th/2,w:tw,h:th,cx:tcx,cy:visualCy};
  }

  // ── Text layer render ─────────────────────────────────────────────────────
  function renderTextLayer(layer, W, H) {
    var hasRealText = !!(layer.text && String(layer.text).trim());
    var drawingPlaceholder = !hasRealText && !!layer.placeholder && !_capturingClean;
    if (!hasRealText && !drawingPlaceholder) return;
    var color=metalFg[spec.metal]||'#1A1A1A';
    var plateColor = metalBg[spec.metal] || '#F5F5F0';
    var sz=layer.size||24;
    var fs=(layer.italic?'italic ':'')+(layer.bold?'bold ':'');
    ctx.font=fs+sz+'px "'+(layer.font||'Arial')+'"';
    ctx.textBaseline='alphabetic';
    ctx.textAlign=layer.align||'center';
    var baseX=layer.align==='left'?W*0.05:layer.align==='right'?W*0.95:W/2;
    baseX+=(layer.x||0)*PPI;
    var centerY=H/2+(layer.y||0)*PPI;
    var text = drawingPlaceholder ? layer.placeholder : layer.text;

    var mmMain = ctx.measureText(text);
    var ascMain = mmMain.actualBoundingBoxAscent != null ? mmMain.actualBoundingBoxAscent : sz * 0.8;
    var descMain = mmMain.actualBoundingBoxDescent != null ? mmMain.actualBoundingBoxDescent : sz * 0.2;
    // Keep layer positioning behavior based on visual center, but render using alphabetic baseline.
    var baseY = centerY + (ascMain - descMain) / 2;
    var b=getLayerBounds(layer);
    var flipX=layer.flipX?-1:1;
    var flipY=layer.flipY?-1:1;
    if (flipX!==1||flipY!==1) {
      ctx.save();
      ctx.translate(b.cx,b.cy);
      ctx.scale(flipX,flipY);
      ctx.translate(-b.cx,-b.cy);
    }

    var pad = Math.max(2, Math.round(sz * 0.14));
    if ((layer.inverted || layer.boxed) && !drawingPlaceholder) {
      var left = mmMain.actualBoundingBoxLeft != null ? mmMain.actualBoundingBoxLeft : 0;
      var right = mmMain.actualBoundingBoxRight != null ? mmMain.actualBoundingBoxRight : (mmMain.width || 0);
      var asc = ascMain;
      var desc = descMain;

      // Build rect directly from alignment point bounds (works with left/right/center textAlign).
      var glyphX = baseX - left;
      var glyphY = baseY - asc;
      var glyphW = left + right;
      var glyphH = asc + desc;

      var rectX = glyphX - pad;
      var rectY = glyphY - pad;
      var rectW = glyphW + pad * 2;
      var rectH = glyphH + pad * 2;
      if (layer.inverted) {
        ctx.save();
        ctx.fillStyle = color;
        ctx.fillRect(rectX, rectY, rectW, rectH);
        ctx.restore();
        color = plateColor;
      }
      if (layer.boxed) {
        ctx.save();
        ctx.strokeStyle = color;
        ctx.lineWidth = Math.max(1, sz * 0.06);
        ctx.strokeRect(rectX, rectY, rectW, rectH);
        ctx.restore();
      }
    }

    if (drawingPlaceholder) ctx.globalAlpha = 0.35;
    if (!drawingPlaceholder && sz>=14) {
      ctx.fillStyle='rgba(0,0,0,0.45)'; ctx.fillText(text,baseX-0.5,baseY-0.5);
      ctx.fillStyle='rgba(255,255,255,0.25)'; ctx.fillText(text,baseX+0.5,baseY+0.5);
    }
    ctx.fillStyle=color; ctx.fillText(text,baseX,baseY);
    if (layer.underline && !drawingPlaceholder) {
      var lw=mmMain.width;
      var ulY=baseY+Math.max(1,sz*0.08);
      var ulX=layer.align==='left'?baseX:layer.align==='right'?baseX-lw:baseX-lw/2;
      ctx.save(); ctx.strokeStyle=color; ctx.lineWidth=Math.max(1,sz*0.06);
      ctx.beginPath(); ctx.moveTo(ulX,ulY); ctx.lineTo(ulX+lw,ulY); ctx.stroke(); ctx.restore();
    }
    if (drawingPlaceholder) ctx.globalAlpha = 1;
    if (flipX!==1||flipY!==1) ctx.restore();
  }

  // ── Clipart layer render ──────────────────────────────────────────────────
  function renderClipartLayer(layer, W, H) {
    if (!layer.clipartId) return;
    var CLIPARTS=window.ENM_CLIPARTS||{};
    var art=CLIPARTS[layer.clipartId]; if (!art) return;
    var r=((layer.clipartSize||1)*PPI)/2;
    var cx=W/2+(layer.x||0)*PPI, cy=H/2+(layer.y||0)*PPI;
    var color=metalFg[spec.metal]||'#1A1A1A';
    var flipX=layer.flipX?-1:1;
    var flipY=layer.flipY?-1:1;
    ctx.save();
    if (layer.rotation||flipX!==1||flipY!==1) {
      ctx.translate(cx,cy);
      if (layer.rotation) ctx.rotate(layer.rotation);
      if (flipX!==1||flipY!==1) ctx.scale(flipX,flipY);
      ctx.translate(-cx,-cy);
    }
    if (art.pathData) {
      var maxDim=Math.max(art.vbW,art.vbH);
      var s=(r*2)/maxDim;
      var path2d=new Path2D(art.pathData);
      ctx.save(); ctx.translate(cx-art.vbCx*s,cy-art.vbCy*s); ctx.scale(s,s);
      ctx.fillStyle=color; ctx.fill(path2d); ctx.restore();
    } else {
      art.draw(ctx,cx,cy,r); ctx.fillStyle=color; ctx.fill();
    }
    ctx.restore();
  }

  function renderCodeLayer(layer) {
    var b = getLayerBounds(layer);
    if (!b || b.w <= 2 || b.h <= 2) return;
    var flipX=layer.flipX?-1:1;
    var flipY=layer.flipY?-1:1;
    var useFlip=(flipX!==1||flipY!==1);
    if (useFlip) {
      ctx.save();
      ctx.translate(b.cx,b.cy);
      ctx.scale(flipX,flipY);
      ctx.translate(-b.cx,-b.cy);
    }
    var content = layer.content || '';
    if (!content) content = layer.type === 'barcode-2d' ? 'ENM-001' : '12345';
    if (layer.format === 'CODE39') content = content.toUpperCase();

    var fgColor = metalFg[spec.metal] || '#1A1A1A';
    var bcid = BCID_MAP[layer.format] || (layer.type === 'barcode-2d' ? 'datamatrix' : 'code128');

    if (typeof bwipjs === 'undefined') {
      ctx.save();
      ctx.strokeStyle = fgColor;
      ctx.strokeRect(b.x, b.y, b.w, b.h);
      ctx.restore();
      if (useFlip) ctx.restore();
      return;
    }

    var oc = document.createElement('canvas');
    try {
      bwipjs.toCanvas(oc, {
        bcid: bcid,
        text: content,
        scale: 2,
        height: 10,
        includetext: layer.type === 'barcode-1d' ? (layer.showText !== false) : false,
        paddingwidth: 0,
        paddingheight: 0
      });
    } catch (e) {
      ctx.save();
      ctx.strokeStyle = '#ef4444';
      ctx.setLineDash([3, 3]);
      ctx.strokeRect(b.x, b.y, b.w, b.h);
      ctx.restore();
      if (useFlip) ctx.restore();
      return;
    }

    var octx = oc.getContext('2d');
    var imgData = octx.getImageData(0, 0, oc.width, oc.height);
    var d = imgData.data;
    var cr = parseInt(fgColor.slice(1, 3), 16);
    var cg = parseInt(fgColor.slice(3, 5), 16);
    var cb = parseInt(fgColor.slice(5, 7), 16);
    for (var pi = 0; pi < d.length; pi += 4) {
      var lum = (d[pi] * 299 + d[pi + 1] * 587 + d[pi + 2] * 114) / 1000;
      if (lum < 128 && d[pi + 3] > 0) {
        d[pi] = cr;
        d[pi + 1] = cg;
        d[pi + 2] = cb;
        d[pi + 3] = 255;
      } else {
        d[pi + 3] = 0;
      }
    }
    octx.putImageData(imgData, 0, 0);

    var pad = Math.round(Math.min(b.w, b.h) * 0.1);
    if (layer.inverted) {
      var invC = document.createElement('canvas');
      invC.width = Math.ceil(b.w + pad * 2);
      invC.height = Math.ceil(b.h + pad * 2);
      var invCtx = invC.getContext('2d');
      invCtx.fillStyle = fgColor;
      invCtx.fillRect(0, 0, invC.width, invC.height);
      invCtx.globalCompositeOperation = 'destination-out';
      invCtx.drawImage(oc, pad, pad, b.w, b.h);
      ctx.drawImage(invC, b.x - pad, b.y - pad);
    } else {
      ctx.drawImage(oc, b.x, b.y, b.w, b.h);
    }

    if (layer.boxed) {
      ctx.save();
      ctx.strokeStyle = fgColor;
      ctx.lineWidth = Math.max(1, Math.round(Math.min(b.w, b.h) * 0.04));
      ctx.strokeRect(b.x - pad, b.y - pad, b.w + pad * 2, b.h + pad * 2);
      ctx.restore();
    }
    if (useFlip) ctx.restore();
  }

  // ── Selection handles ─────────────────────────────────────────────────────
  function renderSelectionHandles(W, H) {
    if (_capturingClean) return;
    var layer=getActiveLayer(); if (!layer) return;
    var b=getLayerBounds(layer);
    var pad=4, bw=b.w+pad*2, bh=b.h+pad*2;
    ctx.save(); ctx.translate(b.cx,b.cy);
    ctx.setLineDash([4,3]); ctx.lineWidth=1.5; ctx.strokeStyle='#007bff';
    ctx.strokeRect(-bw/2,-bh/2,bw,bh); ctx.setLineDash([]);
    // Resize handle bottom-right (blue)
    drawHandle(bw/2,bh/2,'#007bff','resize');
    // Delete handle top-right (red, clipart = remove layer; text = clear text)
    if (layer.type==='clipart' || layer.type==='text') drawHandle(bw/2,-bh/2,'#ef4444','delete');
    // Rotation handle top-center with stem (clipart only)
    if (layer.type==='clipart') {
      var stemLen=22;
      ctx.strokeStyle='#22c55e'; ctx.lineWidth=1.5;
      ctx.beginPath(); ctx.moveTo(0,-bh/2); ctx.lineTo(0,-(bh/2+stemLen)); ctx.stroke();
      drawHandle(0,-(bh/2+stemLen),'#22c55e','rotate');
    }
    ctx.restore();
  }

  function drawHandle(x, y, color, type) {
    var h=HANDLE_H;
    ctx.fillStyle=color; ctx.fillRect(x-h,y-h,h*2,h*2);
    ctx.strokeStyle='#ffffff'; ctx.lineWidth=1.2; ctx.strokeRect(x-h,y-h,h*2,h*2);
    ctx.strokeStyle='#ffffff'; ctx.lineWidth=1.5; ctx.lineCap='round';
    if (type==='delete') {
      ctx.beginPath(); ctx.moveTo(x-h*0.5,y-h*0.5); ctx.lineTo(x+h*0.5,y+h*0.5); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(x+h*0.5,y-h*0.5); ctx.lineTo(x-h*0.5,y+h*0.5); ctx.stroke();
    } else if (type==='rotate') {
      ctx.beginPath(); ctx.arc(x,y,h*0.55,-Math.PI*0.75,Math.PI*0.75,false);
      ctx.strokeStyle='#fff'; ctx.lineWidth=1.5; ctx.stroke();
      ctx.beginPath(); ctx.moveTo(x+h*0.4,y+h*0.55); ctx.lineTo(x+h*0.55,y+h*0.3); ctx.lineTo(x+h*0.1,y+h*0.3); ctx.stroke();
    } else {
      ctx.beginPath(); ctx.moveTo(x-h*0.5,y); ctx.lineTo(x+h*0.5,y); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(x,y-h*0.5); ctx.lineTo(x,y+h*0.5); ctx.stroke();
    }
  }

  function handleAtPoint(px, py) {
    var layer=getActiveLayer(); if (!layer) return null;
    var b=getLayerBounds(layer);
    var pad=4, bw=b.w+pad*2, bh=b.h+pad*2;
    var hit=HANDLE_H+4;
    // Resize: bottom-right corner
    if (Math.abs(px-b.cx-bw/2)<hit && Math.abs(py-b.cy-bh/2)<hit) return {type:'resize',layer:layer};
    // Delete: top-right corner (clipart or text)
    if ((layer.type==='clipart' || layer.type==='text') && Math.abs(px-b.cx-bw/2)<hit && Math.abs(py-b.cy+bh/2)<hit) return {type:'delete',layer:layer};
    // Rotate: top-center (clipart only)
    if (layer.type==='clipart' && Math.abs(px-b.cx)<hit && Math.abs(py-(b.cy-bh/2-22))<hit) return {type:'rotate',layer:layer};
    return null;
  }

  function layerAtPoint(px, py) {
    var found=null;
    layers.slice().reverse().forEach(function(layer) {
      if (found) return;
      if (layer.visible === false) return;
      var b=getLayerBounds(layer);
      var pad=8;
      if (Math.abs(px-b.cx)<=b.w/2+pad && Math.abs(py-b.cy)<=b.h/2+pad) found=layer;
    });
    return found;
  }

  function isLayerSelected(id) {
    return !!_selectedLayerIds[id];
  }

  function getSelectedLayers() {
    var arr = [];
    Object.keys(_selectedLayerIds).forEach(function (id) {
      var lid = parseInt(id, 10);
      var l = layers.find(function (x) { return x.id === lid; });
      if (l) arr.push(l);
    });
    return arr;
  }

  function clearSelectedLayers() {
    _selectedLayerIds = {};
  }

  function ensureActiveInSelection() {
    if (activeLayerId != null) _selectedLayerIds[activeLayerId] = true;
  }

  function toggleLayerSelection(id) {
    if (_selectedLayerIds[id]) delete _selectedLayerIds[id];
    else _selectedLayerIds[id] = true;
  }

  function getActionLayers() {
    var selected = getSelectedLayers();
    if (selected.length > 1) return selected;
    if (_multiSelectMode) {
      if (selected.length) return selected;
    }
    var active = getActiveLayer();
    return active ? [active] : [];
  }

  function clearSnapGuides() {
    _snapGuideX = null;
    _snapGuideY = null;
  }

  function renderGridOverlay(W, H) {
    var step = getGridStepIn() * PPI;
    if (step <= 0) return;
    var minorGridColor = oppositeGridColor[spec.metal] || 'rgba(18,18,18,0.06)';

    ctx.save();
    buildPlatePath(W, H);
    ctx.clip();

    ctx.lineWidth = 1;
    ctx.strokeStyle = minorGridColor;
    ctx.beginPath();
    for (var x = W / 2; x <= W; x += step) { ctx.moveTo(x, 0); ctx.lineTo(x, H); }
    for (var x2 = W / 2 - step; x2 >= 0; x2 -= step) { ctx.moveTo(x2, 0); ctx.lineTo(x2, H); }
    for (var y = H / 2; y <= H; y += step) { ctx.moveTo(0, y); ctx.lineTo(W, y); }
    for (var y2 = H / 2 - step; y2 >= 0; y2 -= step) { ctx.moveTo(0, y2); ctx.lineTo(W, y2); }
    ctx.stroke();

    ctx.strokeStyle = 'rgba(0,123,255,0.22)';
    ctx.lineWidth = 1.2;
    ctx.beginPath();
    ctx.moveTo(W / 2, 0); ctx.lineTo(W / 2, H);
    ctx.moveTo(0, H / 2); ctx.lineTo(W, H / 2);
    ctx.stroke();

    ctx.restore();
  }

  function renderSnapGuides(W, H) {
    if (_snapGuideX === null && _snapGuideY === null) return;
    ctx.save();
    buildPlatePath(W, H);
    ctx.clip();
    ctx.strokeStyle = 'rgba(220,38,38,0.95)';
    ctx.lineWidth = 1.5;
    ctx.setLineDash([5, 3]);
    if (_snapGuideX !== null) {
      var gx = W / 2 + _snapGuideX * PPI;
      ctx.beginPath(); ctx.moveTo(gx, 0); ctx.lineTo(gx, H); ctx.stroke();
    }
    if (_snapGuideY !== null) {
      var gy = H / 2 + _snapGuideY * PPI;
      ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(W, gy); ctx.stroke();
    }
    ctx.restore();
  }

  function renderSelectedLayerOutlines() {
    if (_capturingClean) return;
    var selected = getSelectedLayers();
    if (!selected.length || (!_multiSelectMode && selected.length < 2)) return;
    selected.forEach(function (layer) {
      if (activeLayerId === layer.id) return;
      var b = getLayerBounds(layer);
      var pad = 4, bw = b.w + pad * 2, bh = b.h + pad * 2;
      ctx.save();
      ctx.translate(b.cx, b.cy);
      ctx.setLineDash([3, 3]);
      ctx.lineWidth = 1.2;
      ctx.strokeStyle = 'rgba(56,189,248,0.9)';
      ctx.strokeRect(-bw / 2, -bh / 2, bw, bh);
      ctx.restore();
    });
  }

  function computeAxisSnapPreview(rawCoord, halfSizeIn, axis) {
    var kinds = axis === 'x' ? ['left', 'center', 'right'] : ['top', 'middle', 'bottom'];
    var gridStepIn = getGridStepIn();
    var thresholdPx = getSnapPreviewThresholdPx();

    function anchorFor(kind) {
      if (axis === 'x') {
        if (kind === 'left') return rawCoord - halfSizeIn;
        if (kind === 'right') return rawCoord + halfSizeIn;
        return rawCoord;
      }
      if (kind === 'top') return rawCoord - halfSizeIn;
      if (kind === 'bottom') return rawCoord + halfSizeIn;
      return rawCoord;
    }

    function coordFrom(kind, gridIn) {
      if (axis === 'x') {
        if (kind === 'left') return gridIn + halfSizeIn;
        if (kind === 'right') return gridIn - halfSizeIn;
        return gridIn;
      }
      if (kind === 'top') return gridIn + halfSizeIn;
      if (kind === 'bottom') return gridIn - halfSizeIn;
      return gridIn;
    }

    var best = null;
    kinds.forEach(function (kind) {
      var anchor = anchorFor(kind);
      var nearestGrid = Math.round(anchor / gridStepIn) * gridStepIn;
      var distPx = Math.abs(anchor - nearestGrid) * PPI;
      if (distPx <= thresholdPx && (!best || distPx < best.distPx)) {
        best = { kind: kind, grid: nearestGrid, distPx: distPx };
      }
    });

    if (best) {
      return {
        snapCoord: coordFrom(best.kind, best.grid),
        guide: best.grid
      };
    }

    return null;
  }

  // ── Main canvas render ────────────────────────────────────────────────────
  function renderCanvas() {
    var W=pw(), H=ph();
    ctx.clearRect(0,0,W+1,H+1);
    buildPlatePath(W,H);
    ctx.shadowColor='rgba(0,0,0,0.22)'; ctx.shadowBlur=18; ctx.shadowOffsetY=5;
    ctx.fillStyle=metalBg[spec.metal]||'#E1C16E'; ctx.fill();
    ctx.shadowColor='transparent';
    ctx.save(); buildPlatePath(W,H); ctx.clip(); renderMetalTexture(W,H); ctx.restore();
    if (spec.borderPng) {
      ctx.save();
      buildPlatePath(W, H);
      ctx.clip();
      renderBorderLayer(W, H);
      ctx.restore();
    }
    buildPlatePath(W,H); ctx.strokeStyle='rgba(0,0,0,0.12)'; ctx.lineWidth=1; ctx.stroke();
    if (!_capturingClean && _showGrid) renderGridOverlay(W, H);
    renderHoles(W,H);
    layers.forEach(function(layer) {
      if (layer.visible === false) return;
      if (layer.type==='text') renderTextLayer(layer,W,H);
      else if (layer.type==='clipart') renderClipartLayer(layer,W,H);
      else if (isCodeLayer(layer)) renderCodeLayer(layer);
    });
    if (!_capturingClean) renderSelectedLayerOutlines();
    if (!_capturingClean) renderSnapGuides(W, H);
    if (!_capturingClean) renderSelectionHandles(W,H);
  }

  // ── Drag ─────────────────────────────────────────────────────────────────
  var dragging=false, dragLayer=null, dragMode='move';
  var dragStartX=0, dragStartY=0, dragOriginX=0, dragOriginY=0, dragInitSize=1;
  var dragSnapCommitX = null, dragSnapCommitY = null;
  var dragTapToggle = false;
  var dragTapTargetId = null;
  var dragAdditiveSelect = false;
  var dragGroupOrigins = null;
  var dragGroupSizes = null;

  function startDrag(clientX, clientY, additiveSelect) {
    var pt=getCanvasPoint(clientX,clientY);
    var handle=handleAtPoint(pt.px,pt.py);
    if (handle) {
      clearSnapGuides();
      dragSnapCommitX = null;
      dragSnapCommitY = null;
      if (handle.type==='delete') {
        if (handle.layer.type==='text') {
          handle.layer.text='';
          var inp=document.getElementById('enm-v2-line-'+(handle.layer._lineIndex||0));
          if (inp){inp.value='';var ctr=document.getElementById('enm-v2-counter-'+(handle.layer._lineIndex||0));if(ctr)ctr.textContent='0/'+maxChars();}
          renderCanvas(); return;
        }
        removeClipartLayer(handle.layer.id); return;
      }
      if (handle.type==='rotate') {
        var pt0=getCanvasPoint(clientX,clientY);
        var b0=getLayerBounds(handle.layer);
        dragging=true; dragLayer=handle.layer; dragMode='rotate';
        dragStartX=Math.atan2(pt0.py-b0.cy,pt0.px-b0.cx);
        dragOriginX=handle.layer.rotation||0;
        return;
      }
      dragging=true; dragLayer=handle.layer; dragMode='resize';
      dragStartX=clientX; dragStartY=clientY;
      dragOriginX=handle.layer.x||0; dragOriginY=handle.layer.y||0;
      if (handle.layer.type === 'clipart') dragInitSize = handle.layer.clipartSize || 1;
      else if (handle.layer.type === 'barcode-2d') dragInitSize = handle.layer.size || 0.6;
      else if (handle.layer.type === 'barcode-1d') dragInitSize = handle.layer.width || 1.8;
      else dragInitSize = handle.layer.size || 24;
      dragTapTargetId = null;
      dragAdditiveSelect = false;
      var resizeLayers=getActionLayers();
      if (resizeLayers.length>1) {
        dragGroupSizes=resizeLayers.map(function(l){
          var s = l.type==='clipart'?(l.clipartSize||1):l.type==='barcode-2d'?(l.size||0.6):l.type==='barcode-1d'?(l.width||1.8):(l.size||24);
          return {id:l.id,type:l.type,size:s};
        });
      } else { dragGroupSizes=null; }
      return;
    }
    var hit=layerAtPoint(pt.px,pt.py);
    if (hit) {
      dragging=true; dragLayer=hit; dragMode='move';
      clearSnapGuides();
      dragSnapCommitX = null;
      dragSnapCommitY = null;
      dragStartX=clientX; dragStartY=clientY;
      dragOriginX=hit.x||0; dragOriginY=hit.y||0;
      dragTapToggle = !!(_multiSelectMode || additiveSelect);
      dragTapTargetId = hit.id;
      dragAdditiveSelect = !!additiveSelect;

      if (_multiSelectMode || additiveSelect) {
        // Anchor the currently active layer into the selection set before adding the new one
        if (additiveSelect && !_multiSelectMode && activeLayerId != null && !isLayerSelected(activeLayerId)) {
          _selectedLayerIds[activeLayerId] = true;
        }
        var selected = getSelectedLayers();
        var groupSet = selected.slice();
        if (!isLayerSelected(hit.id)) groupSet.push(hit);
        dragGroupOrigins = groupSet.map(function (l) {
          return { id: l.id, x: l.x || 0, y: l.y || 0 };
        });
      } else {
        clearSelectedLayers();
        dragGroupOrigins = null;
      }
      setActiveLayer(hit.id);
    } else {
      dragTapToggle = false;
      dragTapTargetId = null;
      dragAdditiveSelect = false;
      dragGroupOrigins = null;
      if (_multiSelectMode) clearSelectedLayers();
      if (activeLayerId!=null) { activeLayerId=null; syncActiveLayerControls(); renderCanvas(); }
    }
  }

  function updateDrag(clientX, clientY) {
    if (!dragging||!dragLayer) return;
    var dx=clientX-dragStartX, dy=clientY-dragStartY;
    var rect=canvas.getBoundingClientRect();
    if (dragMode==='move') {
      if (dragTapToggle && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) dragTapToggle = false;
      if (dragTapToggle) return;

      var pxPerIn=rect.width/spec.width;
      var rawX=dragOriginX+dx/pxPerIn;
      var rawY=dragOriginY+dy/pxPerIn;

      if (dragGroupOrigins && dragGroupOrigins.length > 1 && isLayerSelected(dragLayer.id)) {
        clearSnapGuides();
        dragGroupOrigins.forEach(function (g) {
          var layer = layers.find(function (l) { return l.id === g.id; });
          if (!layer) return;
          layer.x = g.x + dx / pxPerIn;
          layer.y = g.y + dy / pxPerIn;
        });
        dragSnapCommitX = null;
        dragSnapCommitY = null;
        renderCanvas();
        return;
      }

      var baseX=dragLayer.x;
      var baseY=dragLayer.y;
      dragLayer.x=rawX;
      dragLayer.y=rawY;
      var b=getLayerBounds(dragLayer);
      var halfWIn=Math.max(0,b.w/(2*PPI));
      var halfHIn=Math.max(0,b.h/(2*PPI));
      dragLayer.x=baseX;
      dragLayer.y=baseY;

      var snapX=computeAxisSnapPreview(rawX,halfWIn,'x');
      var snapY=computeAxisSnapPreview(rawY,halfHIn,'y');
      dragLayer.x=rawX;
      dragLayer.y=rawY;
      dragSnapCommitX=snapX?snapX.snapCoord:null;
      dragSnapCommitY=snapY?snapY.snapCoord:null;
      _snapGuideX=snapX?snapX.guide:null;
      _snapGuideY=snapY?snapY.guide:null;
    } else if (dragMode==='rotate') {
      clearSnapGuides();
      var pt2=getCanvasPoint(clientX,clientY);
      var b2=getLayerBounds(dragLayer);
      var currentAngle=Math.atan2(pt2.py-b2.cy,pt2.px-b2.cx);
      dragLayer.rotation=dragOriginX+(currentAngle-dragStartX);
    } else if (dragMode==='resize') {
      clearSnapGuides();
      var delta=(dx+dy)/2;
      var pxPerIn2=rect.width/spec.width;
      var newSize=null;
      if (dragLayer.type==='clipart') {
        newSize=Math.max(0.2,+(dragInitSize+delta/pxPerIn2).toFixed(2));
        dragLayer.clipartSize=newSize;
      } else if (dragLayer.type === 'barcode-1d') {
        dragLayer.width = Math.max(0.6, +(dragLayer.width + (dx / pxPerIn2)).toFixed(2));
        dragLayer.height = Math.max(0.2, +(dragLayer.height + (dy / pxPerIn2)).toFixed(2));
      } else if (dragLayer.type === 'barcode-2d') {
        newSize = Math.max(0.3, +(dragInitSize+(delta / pxPerIn2)).toFixed(2));
        dragLayer.size = newSize;
      } else {
        newSize=Math.max(6,Math.round(dragInitSize+delta/(pxPerIn2/PPI)));
        dragLayer.size=newSize;
      }
      if (dragGroupSizes && dragInitSize>0 && newSize!=null) {
        var ratio=newSize/dragInitSize;
        dragGroupSizes.forEach(function(gs){
          if (gs.id===dragLayer.id) return;
          var l=layers.find(function(x){return x.id===gs.id;});
          if (!l) return;
          if (l.type==='clipart') l.clipartSize=Math.max(0.2,+(gs.size*ratio).toFixed(2));
          else if (l.type==='barcode-2d') l.size=Math.max(0.3,+(gs.size*ratio).toFixed(2));
          else if (l.type==='barcode-1d') l.width=Math.max(0.6,+(gs.size*ratio).toFixed(2));
          else l.size=Math.max(6,Math.round(gs.size*ratio));
        });
      }
    }
    renderCanvas();
  }

  function endDrag() {
    var shouldRerender = false;
    if (dragging && dragLayer && dragMode === 'move' && dragTapToggle && (_multiSelectMode || dragAdditiveSelect) && dragTapTargetId != null) {
      toggleLayerSelection(dragTapTargetId);
      var selected = getSelectedLayers();
      if (selected.length) activeLayerId = selected[selected.length - 1].id;
      else activeLayerId = null;
      syncActiveLayerControls();
      shouldRerender = true;
    }
    if (dragging && dragLayer && dragMode === 'move') {
      if (!dragTapToggle) {
        if (dragSnapCommitX != null) { dragLayer.x = dragSnapCommitX; shouldRerender = true; }
        if (dragSnapCommitY != null) { dragLayer.y = dragSnapCommitY; shouldRerender = true; }
      }
    }
    dragging=false;
    dragLayer=null;
    dragSnapCommitX = null;
    dragSnapCommitY = null;
    dragTapToggle = false;
    dragTapTargetId = null;
    dragAdditiveSelect = false;
    dragGroupOrigins = null;
    dragGroupSizes = null;
    if (_snapGuideX !== null || _snapGuideY !== null) {
      clearSnapGuides();
      shouldRerender = true;
    }
    if (shouldRerender) renderCanvas();
  }

  canvas.addEventListener('mousedown',function(e){startDrag(e.clientX,e.clientY,!!e.shiftKey);});
  window.addEventListener('mousemove',function(e){if(dragging)updateDrag(e.clientX,e.clientY);});
  window.addEventListener('mouseup',endDrag);
  canvas.addEventListener('touchstart',function(e){if(e.touches.length!==1)return;e.preventDefault();startDrag(e.touches[0].clientX,e.touches[0].clientY,false);},{passive:false});
  canvas.addEventListener('touchmove',function(e){if(e.touches.length!==1)return;e.preventDefault();updateDrag(e.touches[0].clientX,e.touches[0].clientY);},{passive:false});
  canvas.addEventListener('touchend',function(e){e.preventDefault();endDrag();},{passive:false});

  // ── Active layer ──────────────────────────────────────────────────────────
  function getActiveLayer() {
    return layers.find(function(l){return l.id===activeLayerId;})||null;
  }

  function setActiveLayer(id) {
    activeLayerId=id;
    if (_multiSelectMode) ensureActiveInSelection();
    syncActiveLayerControls(); renderCanvas();
    syncCodePanel();
    buildLayersList();
    // Highlight the corresponding line input if it's a text layer
    var layer=getActiveLayer();
    if (layer&&layer.type==='text'&&layer._lineIndex!=null) {
      var inp=document.getElementById('enm-v2-line-'+layer._lineIndex);
      if (inp) inp.focus({preventScroll:true});
    }
  }

  function syncActiveLayerControls() {
    var layer=getActiveLayer();
    var boldBtn=document.getElementById('enm-v2-bold');
    var italicBtn=document.getElementById('enm-v2-italic');
    var ulBtn=document.getElementById('enm-v2-underline');
    var invertBtn=document.getElementById('enm-v2-text-invert');
    var boxBtn=document.getElementById('enm-v2-text-box');
    var controlsEl=document.getElementById('enm-v2-layer-controls');
    var hasText=layer&&layer.type==='text';
    var textInputs = document.querySelectorAll('#enm-v2-lines-wrap .enm-v2__line-input');
    if (controlsEl) controlsEl.style.opacity=hasText?'1':'0.4';
    textInputs.forEach(function (inp) {
      // Keep inputs focusable so clicking a text field can switch active layer
      // from barcode -> text directly within the same accordion panel.
      inp.readOnly = !hasText;
      inp.setAttribute('aria-disabled', !hasText ? 'true' : 'false');
    });
    // Update custom font picker display to reflect active layer's font
    if (hasText&&window._enmV2SetFontDisplay) window._enmV2SetFontDisplay(layer.font||'Arial');
    [boldBtn,italicBtn,ulBtn].forEach(function(btn,i){
      if (!btn) return;
      btn.disabled=!hasText;
      var prop=['bold','italic','underline'][i];
      var active=hasText&&!!layer[prop];
      btn.classList.toggle('enm-v2__pill-btn--active',active);
      btn.setAttribute('aria-pressed',active?'true':'false');
    });
    [
      [invertBtn, hasText && !!layer.inverted],
      [boxBtn, hasText && !!layer.boxed]
    ].forEach(function (entry) {
      var btn = entry[0];
      var active = entry[1];
      if (!btn) return;
      btn.disabled = !hasText;
      btn.classList.toggle('enm-v2__pill-btn--active', !!active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var flipHBtn=document.getElementById('enm-v2-flip-h');
    var flipVBtn=document.getElementById('enm-v2-flip-v');
    var selectModeBtn=document.getElementById('enm-v2-select-mode');
    [flipHBtn,flipVBtn].forEach(function(btn){ if (btn) btn.disabled=!layer; });
    if (flipHBtn) flipHBtn.setAttribute('aria-pressed',layer&&layer.flipX?'true':'false');
    if (flipVBtn) flipVBtn.setAttribute('aria-pressed',layer&&layer.flipY?'true':'false');
    if (selectModeBtn) selectModeBtn.setAttribute('aria-pressed',_multiSelectMode?'true':'false');
  }

  function toggleLayerFlip(axis) {
    var targets=getActionLayers();
    if (!targets.length) return;
    targets.forEach(function(layer){
      if (axis==='x') layer.flipX=!layer.flipX;
      else layer.flipY=!layer.flipY;
    });
    syncActiveLayerControls();
    renderCanvas();
  }

  // ── Custom font picker ────────────────────────────────────────────────────
  (function(){
    var trigger=document.getElementById('enm-v2-font-trigger');
    var display=document.getElementById('enm-v2-font-display');
    var list=document.getElementById('enm-v2-font-list');
    var hiddenSel=document.getElementById('enm-v2-active-font');
    if (!trigger||!list) return;

    // Build list items + populate hidden select
    FONTS.forEach(function(f){
      var item=document.createElement('div');
      item.className='enm-v2__font-opt';
      item.setAttribute('role','option');
      item.dataset.fontName=f.name;
      item.dataset.fontFamily=f.family;
      item.style.fontFamily=f.family;
      item.textContent=f.name;
      item.addEventListener('click',function(){
        applyFont(f.name,f.family);
        closeList();
      });
      list.appendChild(item);
      if (hiddenSel){var o=document.createElement('option');o.value=f.name;o.textContent=f.name;hiddenSel.appendChild(o);}
    });

    function openList(){
      list.style.display='block';
      trigger.setAttribute('aria-expanded','true');
    }
    function closeList(){
      list.style.display='none';
      trigger.setAttribute('aria-expanded','false');
    }
    function applyFont(name,family){
      // Apply to the focused/active text layer; fall back to all if none active
      var active=getActiveLayer();
      if(active&&active.type==='text'){active.font=name;}
      else{layers.forEach(function(l){if(l.type==='text')l.font=name;});}
      // Update display
      if(display){display.textContent=name;display.style.fontFamily=family;}
      if(hiddenSel)hiddenSel.value=name;
      // Mark active item
      list.querySelectorAll('.enm-v2__font-opt').forEach(function(el){
        el.classList.toggle('enm-v2__font-opt--active',el.dataset.fontName===name);
      });
      renderCanvas();
    }
    // Expose for syncActiveLayerControls
    window._enmV2SetFontDisplay=function(name){
      var f=FONTS.find(function(x){return x.name===name;})||FONTS[0];
      if(display){display.textContent=f.name;display.style.fontFamily=f.family;}
      list.querySelectorAll('.enm-v2__font-opt').forEach(function(el){
        el.classList.toggle('enm-v2__font-opt--active',el.dataset.fontName===f.name);
      });
    };

    trigger.addEventListener('click',function(e){
      e.stopPropagation();
      if(trigger.getAttribute('aria-expanded')==='true')closeList();else openList();
    });
    document.addEventListener('click',function(e){
      var picker=document.getElementById('enm-v2-font-picker');
      if(picker&&!picker.contains(e.target))closeList();
    });
  })();

  // ── B/I/U controls wiring ────────────────────────────────────────────────
  ['enm-v2-bold','enm-v2-italic','enm-v2-underline','enm-v2-text-invert','enm-v2-text-box'].forEach(function(id){
    var el=document.getElementById(id); if (!el) return;
    var prop=
      id==='enm-v2-bold'?'bold':
      id==='enm-v2-italic'?'italic':
      id==='enm-v2-underline'?'underline':
      id==='enm-v2-text-invert'?'inverted':'boxed';
    el.addEventListener('click',function(){
      var l=getActiveLayer(); if (!l||l.type!=='text') return;
      l[prop]=!l[prop];
      el.classList.toggle('enm-v2__pill-btn--active',!!l[prop]);
      el.setAttribute('aria-pressed',l[prop]?'true':'false');
      renderCanvas();
    });
  });


  // ── Snap buttons ──────────────────────────────────────────────────────────
  function snapLayer(layer, snapH, snapV, silent) {
    var halfW=spec.width/2, halfH=spec.height/2;
    if (snapH!==null) {
      if (layer.type==='text') {
        if (snapH==='left') layer.x=-halfW*0.88;
        else if (snapH==='right') layer.x=halfW*0.88;
        else layer.x=0;
      } else {
        var r=(layer.clipartSize||1)/2+spec.width*0.04;
        if (snapH==='left') layer.x=-halfW+r;
        else if (snapH==='right') layer.x=halfW-r;
        else layer.x=0;
      }
    }
    if (snapV!==null) {
      if (layer.type==='text') {
        var margin=((layer.size||24)/PPI)*0.8;
        if (snapV==='top') layer.y=-halfH+margin;
        else if (snapV==='bottom') layer.y=halfH-margin;
        else layer.y=0;
      } else {
        var r2=(layer.clipartSize||1)/2+spec.height*0.04;
        if (snapV==='top') layer.y=-halfH+r2;
        else if (snapV==='bottom') layer.y=halfH-r2;
        else layer.y=0;
      }
    }
    if (!silent) renderCanvas();
  }

  function fitLayerToPlate(layer, silent) {
    var b=getLayerBounds(layer);
    if (!b||b.w<=1||b.h<=1) return;
    var fitRatio=0.90;
    var scale=Math.min((pw()*fitRatio)/b.w,(ph()*fitRatio)/b.h);
    if (!isFinite(scale)||scale<=0) return;

    if (layer.type==='clipart') {
      layer.clipartSize=Math.max(0.2,+((layer.clipartSize||1)*scale).toFixed(2));
    } else if (layer.type==='barcode-1d') {
      layer.width=Math.max(0.2,+((layer.width||1.8)*scale).toFixed(2));
      layer.height=Math.max(0.1,+((layer.height||0.45)*scale).toFixed(2));
    } else if (layer.type==='barcode-2d') {
      layer.size=Math.max(0.15,+((layer.size||0.6)*scale).toFixed(2));
    } else {
      layer.size=Math.max(6,Math.round((layer.size||24)*scale));
    }
    if (!silent) renderCanvas();
  }

  [['enm-v2-snap-left','left',null],['enm-v2-snap-hcenter','center',null],['enm-v2-snap-right','right',null],
   ['enm-v2-snap-top',null,'top'],['enm-v2-snap-vcenter',null,'middle'],['enm-v2-snap-bottom',null,'bottom']
  ].forEach(function(cfg){
    var el=document.getElementById(cfg[0]);
    if (el) el.addEventListener('click',function(){
      var targets=getActionLayers();
      if(!targets.length) return;
      targets.forEach(function(l){ snapLayer(l,cfg[1],cfg[2],true); });
      renderCanvas();
    });
  });
  var snapCenterEl=document.getElementById('enm-v2-snap-center');
  if (snapCenterEl) snapCenterEl.addEventListener('click',function(){
    var targets=getActionLayers();
    if(!targets.length) return;
    targets.forEach(function(l){ l.x=0; l.y=0; });
    renderCanvas();
  });
  var snapFitEl=document.getElementById('enm-v2-snap-fit');
  if (snapFitEl) snapFitEl.addEventListener('click',function(){
    var targets=getActionLayers();
    if(!targets.length) return;
    targets.forEach(function(l){ fitLayerToPlate(l,true); });
    renderCanvas();
  });
  var selectModeEl=document.getElementById('enm-v2-select-mode');
  if (selectModeEl) {
    selectModeEl.addEventListener('click',function(){
      _multiSelectMode=!_multiSelectMode;
      if (_multiSelectMode) ensureActiveInSelection();
      else clearSelectedLayers();
      syncActiveLayerControls();
      renderCanvas();
    });
  }
  var flipHEl=document.getElementById('enm-v2-flip-h');
  if (flipHEl) flipHEl.addEventListener('click',function(){ toggleLayerFlip('x'); });
  var flipVEl=document.getElementById('enm-v2-flip-v');
  if (flipVEl) flipVEl.addEventListener('click',function(){ toggleLayerFlip('y'); });
  var gridToggleEl=document.getElementById('enm-v2-grid-toggle');
  if (gridToggleEl) {
    syncGridToggleUI();
    gridToggleEl.addEventListener('click',function(){
      _showGrid=!_showGrid;
      gridToggleEl.setAttribute('aria-pressed',_showGrid?'true':'false');
      saveGridPreference();
      renderCanvas();
    });
  }

  // ── Text layers (pre-created, one per maxLines) ───────────────────────────
  function initTextLayers(oldWidth, oldHeight) {
    var n = maxLines(), h = spec.height;
    // Preserve existing text content and all non-text layers (clipart, code, etc.)
    var oldTextLayers = layers.filter(function(l){return l.type==='text';});
    var otherLayers = layers.filter(function(l){return l.type!=='text';});
    layers = [];
    var fontSize = Math.max(10, Math.min(48, Math.round(h*PPI/(n*1.6))));
    for (var i = 0; i < n; i++) {
      var y = n === 1 ? 0 : (i - (n-1)/2) * h / (n+1);
      // Try to match by field, then by index
      var oldLayer = oldTextLayers[i];
      // If field exists, prefer matching by field
      if (!oldLayer && oldTextLayers.length) {
        var targetField = (typeof _tagTemplates !== 'undefined' && _tagTemplates[0] && _tagTemplates[0].fields && _tagTemplates[0].fields[i]) ? _tagTemplates[0].fields[i].name : null;
        if (targetField) {
          oldLayer = oldTextLayers.find(function(l){ return l.field === targetField; });
        }
      }
      var newSize = fontSize, newX = 0, newY = y;
      if (oldLayer) {
        // Preserve size and position, scaling proportionally if dimensions changed
        var heightRatio = (oldHeight != null && oldHeight > 0) ? h / oldHeight : 1;
        var widthRatio = (oldWidth != null && oldWidth > 0) ? spec.width / oldWidth : 1;
        newSize = Math.max(6, Math.round((oldLayer.size || fontSize) * heightRatio));
        newX = oldLayer.x * (widthRatio);
        newY = oldLayer.y * (heightRatio);
      }
      var newLayer = {
        id: oldLayer ? oldLayer.id : nextLayerId++,
        type: 'text',
        text: oldLayer ? oldLayer.text : '',
        font: oldLayer ? oldLayer.font : 'Arial',
        size: newSize,
        align: oldLayer ? oldLayer.align : 'center',
        bold: oldLayer ? oldLayer.bold : false,
        italic: oldLayer ? oldLayer.italic : false,
        underline: oldLayer ? oldLayer.underline : false,
        inverted: oldLayer ? oldLayer.inverted : false,
        boxed: oldLayer ? oldLayer.boxed : false,
        x: newX,
        y: newY,
        flipX: oldLayer ? !!oldLayer.flipX : false,
        flipY: oldLayer ? !!oldLayer.flipY : false,
        _lineIndex: i,
        field: oldLayer ? oldLayer.field : undefined
      };
      layers.push(newLayer);
    }
    // Restore code and other non-text layers
    otherLayers.forEach(function(l){layers.push(l);});
  }

  function buildLineInputs() {
    var mc=maxChars();
    var wrap=document.getElementById('enm-v2-lines-wrap');
    if (!wrap) return;
    wrap.innerHTML='';
    var textLayers=getTextLayers();
    var n=textLayers.length;
    for (var j=0;j<n;j++) {
      (function(idx){
        var existing=textLayers[idx]||{};
        var row=document.createElement('div');
        row.className='enm-v2__line-row';
        var lbl=document.createElement('div');
        lbl.className='enm-v2__line-label';
        var lineSpan=document.createElement('span');
        lineSpan.textContent=existing.label || (existing.field ? ('Field: ' + existing.field) : (idx===0?'Line1*':'Line'+(idx+1)));
        var counter=document.createElement('span');
        counter.className='enm-v2__line-counter';
        counter.id='enm-v2-counter-'+idx;
        lbl.appendChild(lineSpan); lbl.appendChild(counter);
        var inp=document.createElement('input');
        inp.type='text'; inp.className='enm-v2__line-input';
        inp.id='enm-v2-line-'+idx; inp.maxLength=mc;
        inp.placeholder=idx===0?'Your text here':'';
        inp.value=existing.text||'';
        inp.placeholder=existing.placeholder||inp.placeholder;
        inp.readOnly=!(getActiveLayer()&&getActiveLayer().type==='text');
        counter.textContent=(inp.value.length)+'/'+mc;
        inp.addEventListener('input',function(){
          var tl=textLayers[idx];
          if (tl) {
            tl.text=inp.value;
            syncLinkedCodesForTextLayer(tl);
          }
          counter.textContent=inp.value.length+'/'+mc;
          renderCanvas();
          buildLayersList();
        });
        inp.addEventListener('focus',function(){
          var tl=textLayers[idx];
          if (tl) {
            if (activeLayerId!==tl.id) setActiveLayer(tl.id);
            else { syncActiveLayerControls(); renderCanvas(); }
          }
          syncCodePanel();
        });
        row.addEventListener('click', function () {
          var tl = textLayers[idx];
          if (!tl) return;
          if (activeLayerId !== tl.id) setActiveLayer(tl.id);
          if (inp.readOnly) {
            inp.readOnly = false;
            inp.setAttribute('aria-disabled', 'false');
          }
          inp.focus({preventScroll:true});
        });
        row.appendChild(lbl); row.appendChild(inp);
        wrap.appendChild(row);
      })(j);
    }
  }

  // ── Clipart management ────────────────────────────────────────────────────
  function addClipartLayer(clipartId) {
    var count=layers.filter(function(l){return l.type==='clipart';}).length;
    if (count>=maxCliparts()) return;
    var initSize=Math.min(spec.height*0.45,spec.width*0.22,1.2);
    var layer={
      id:nextLayerId++, type:'clipart', clipartId:clipartId,
      clipartSize:Math.max(0.3,initSize), x:0, y:0, rotation:0
    };
    layers.push(layer);
    setActiveLayer(layer.id);
    renderCanvas();
  }

  function removeClipartLayer(id) {
    layers=layers.filter(function(l){return l.id!==id;});
    if (activeLayerId===id){activeLayerId=null;syncActiveLayerControls();}
    renderCanvas();
    refreshClipartGrid();
  }

  function refreshClipartGrid() {
    var cat=_activeClipartCat;
    if (cat) buildClipartGrid(cat);
  }

  function syncLinkedCodesForTextLayer(textLayer) {
    if (!textLayer) return;
    layers.forEach(function (l) {
      if (!isCodeLayer(l) || l.contentLinked === false) return;
      // ID-based link (set via source select in the new UI)
      if (l.linkedLayerId && l.linkedLayerId === textLayer.id) {
        l.content = textLayer.text || '';
      }
      // Field-based link (set via template definitions — backward compat)
      else if (!l.linkedLayerId && l.field && textLayer.field && l.field === textLayer.field) {
        l.content = textLayer.text || '';
      }
    });
  }

  function addCodeLayer(type) {
    var existingCode = layers.find(function (l) { return isCodeLayer(l); }) || null;
    if (existingCode) {
      if (type === 'barcode-1d') {
        existingCode.type = 'barcode-1d';
        existingCode.width = existingCode.width || 1.8;
        existingCode.height = existingCode.height || 0.45;
        existingCode.format = CODE_FORMATS_1D.indexOf(existingCode.format) !== -1 ? existingCode.format : CODE_FORMATS_1D[0];
        existingCode.label = 'Barcode 1D';
        existingCode.showText = existingCode.showText !== false;
      } else {
        existingCode.type = 'barcode-2d';
        existingCode.size = existingCode.size || 0.6;
        existingCode.format = CODE_FORMATS_2D.indexOf(existingCode.format) !== -1 ? existingCode.format : CODE_FORMATS_2D[0];
        existingCode.label = 'Code 2D';
        existingCode.showText = false;
      }
      setActiveLayer(existingCode.id);
      buildLayersList();
      syncCodePanel();
      renderCanvas();
      return;
    }

    var layer = {
      id: nextLayerId++,
      type: type,
      x: 0,
      y: 0,
      visible: true,
      content: '',
      contentLinked: false,
      inverted: false,
      boxed: false,
      showText: true
    };
    if (type === 'barcode-1d') {
      layer.width = 1.8;
      layer.height = 0.45;
      layer.format = CODE_FORMATS_1D[0];
      layer.content = '12345';
      layer.label = 'Barcode 1D';
    } else {
      layer.size = 0.6;
      layer.format = CODE_FORMATS_2D[0];
      layer.content = 'ENM-001';
      layer.label = 'Code 2D';
      layer.showText = false;
    }
    layers.push(layer);
    setActiveLayer(layer.id);
    buildLayersList();
    syncCodePanel();
  }

  function removeLayer(id) {
    layers = layers.filter(function (l) { return l.id !== id; });
    if (activeLayerId === id) activeLayerId = null;
    buildLayersList();
    syncCodePanel();
    renderCanvas();
  }

  function buildLayersList() {
    var list = document.getElementById('enm-v2-layers-list');
    if (!list) return;
    list.innerHTML = '';
    layers.forEach(function (l) {
      var row = document.createElement('div');
      row.className = 'enm-v2__layer-item' + (l.id === activeLayerId ? ' enm-v2__layer-item--active' : '');
      row.addEventListener('click', function () {
        setActiveLayer(l.id);
        syncCodePanel();
        buildLayersList();
      });

      var label = document.createElement('span');
      if (l.type === 'text') label.textContent = l.label || l.field || ('Text ' + l.id);
      else if (l.type === 'clipart') label.textContent = 'Clipart: ' + (l.clipartId || l.id);
      else label.textContent = (l.type === 'barcode-1d' ? '1D: ' : '2D: ') + (l.field || l.content || 'Code');

      var right = document.createElement('div');
      right.style.display = 'flex';
      right.style.gap = '6px';

      var eye = document.createElement('button');
      eye.type = 'button';
      eye.className = 'enm-v2__layer-eye';
      eye.textContent = l.visible === false ? 'Show' : 'Hide';
      eye.addEventListener('click', function (e) {
        e.stopPropagation();
        l.visible = l.visible === false ? true : false;
        buildLayersList();
        renderCanvas();
      });
      right.appendChild(eye);

      if (l.template !== true) {
        var del = document.createElement('button');
        del.type = 'button';
        del.className = 'enm-v2__layer-eye';
        del.textContent = 'Del';
        del.addEventListener('click', function (e) {
          e.stopPropagation();
          removeLayer(l.id);
        });
        right.appendChild(del);
      }

      row.appendChild(label);
      row.appendChild(right);
      list.appendChild(row);
    });
  }

  function syncCodePanel() {
    var form = document.getElementById('enm-v2-code-form');
    if (form) form.style.display = '';  // always show the form

    var layer = getActiveLayer();
    var existingCodeLayer = layers.find(function (l) { return isCodeLayer(l); }) || null;
    var panelLayer = isCodeLayer(layer) ? layer : existingCodeLayer;
    var fmt = document.getElementById('enm-v2-code-format');
    if (fmt) {
      fmt.value = panelLayer ? (panelLayer.format || 'CODE128') : '';
    }

    // ── Show/hide code-specific controls based on layer type ─────────────
    var pillGroup = fmt ? fmt.parentElement.querySelector('.enm-v2__pill-group') : null;
    var linkSelGroup = document.querySelector('[id^="enm-v2-code-link-sel"]')?.parentElement;
    var contentRow = document.getElementById('enm-v2-code-content-row');
    var showTextBtn = document.getElementById('enm-v2-code-showtext');
    var codeFields = document.getElementById('enm-v2-code-fields');
    if (codeFields) codeFields.classList.remove('enm-v2__code-fields--disabled');

    if (!panelLayer) {
      // No code layer: hide all controls
      if (pillGroup) pillGroup.style.display = 'none';
      if (linkSelGroup) linkSelGroup.style.display = 'none';
      if (contentRow) contentRow.style.display = 'none';
      if (showTextBtn) showTextBtn.style.display = 'none';
      return;
    }

    // Code layer exists: show controls
    if (pillGroup) pillGroup.style.display = '';
    if (linkSelGroup) linkSelGroup.style.display = '';
    if (contentRow) contentRow.style.display = '';
    if (showTextBtn) showTextBtn.style.display = panelLayer.type === 'barcode-1d' ? '' : 'none';

    // ── Invert / Box pill buttons ───────────────────────────────────────────
    var invertBtn = document.getElementById('enm-v2-code-invert');
    var boxBtn    = document.getElementById('enm-v2-code-box');
    if (invertBtn) {
      invertBtn.classList.toggle('enm-v2__pill-btn--active', !!panelLayer.inverted);
      invertBtn.setAttribute('aria-pressed', panelLayer.inverted ? 'true' : 'false');
    }
    if (boxBtn) {
      boxBtn.classList.toggle('enm-v2__pill-btn--active', !!panelLayer.boxed);
      boxBtn.setAttribute('aria-pressed', panelLayer.boxed ? 'true' : 'false');
    }

    // ── Source select (text layers + custom) ───────────────────────────────
    var linkSel = document.getElementById('enm-v2-code-link-sel');
    if (linkSel) {
      linkSel.innerHTML = '';
      var hasSelectableTextSource = false;
      getTextLayers().forEach(function (tl) {
        var o = document.createElement('option');
        o.value = 'layer-' + tl.id;
        var hasEnteredText = !!(tl.text && String(tl.text).trim());
        o.textContent = (tl.label || tl.field || ('Line ' + ((tl._lineIndex || 0) + 1))) + (hasEnteredText ? '' : ' (empty)');
        o.disabled = !hasEnteredText;
        if (hasEnteredText) hasSelectableTextSource = true;
        linkSel.appendChild(o);
      });
      var customOpt = document.createElement('option');
      customOpt.value = 'custom';
      customOpt.textContent = 'Custom text…';
      linkSel.appendChild(customOpt);
      if (panelLayer.linkedLayerId) {
        linkSel.value = 'layer-' + panelLayer.linkedLayerId;
        if (!linkSel.value) linkSel.value = 'custom'; // guard if layer was deleted
      } else {
        linkSel.value = 'custom';
      }
      if (linkSel.value !== 'custom') {
        var selectedOpt = linkSel.options[linkSel.selectedIndex];
        if (selectedOpt && selectedOpt.disabled) linkSel.value = 'custom';
      }
      if (!hasSelectableTextSource) linkSel.value = 'custom';
    }

    // ── Content input (hidden when linked) ─────────────────────────────────
    var contentInput = document.getElementById('enm-v2-code-content');
    var isLinked = !!panelLayer.linkedLayerId;
    if (contentRow)   contentRow.style.display = isLinked ? 'none' : '';
    if (contentInput) contentInput.value = panelLayer.content || '';

    // ── Show text (1D only) ────────────────────────────────────────────────
    if (showTextBtn) {
      var isTextOn = panelLayer.showText !== false;
      showTextBtn.classList.toggle('enm-v2__code-show-btn--off', !isTextOn);
      showTextBtn.setAttribute('aria-pressed', isTextOn ? 'true' : 'false');
      showTextBtn.setAttribute('title', isTextOn ? 'Hide code text' : 'Show code text');
      var slash = showTextBtn.querySelector('.enm-v2__eye-slash');
      if (slash) slash.style.display = isTextOn ? 'none' : '';
    }

    // Keep code controls interactive whenever a code layer exists.
    var shouldDisable = false;
    var disableEls = [fmt, linkSel, contentInput, invertBtn, boxBtn, showTextBtn];
    disableEls.forEach(function (el) {
      if (!el) return;
      el.disabled = shouldDisable;
      el.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
    });
  }

  function bindCodeControls() {
    function getOrActivateCodeLayer() {
      var codeLayer = layers.find(function (l) { return isCodeLayer(l); }) || null;
      if (codeLayer && activeLayerId !== codeLayer.id) setActiveLayer(codeLayer.id);
      return codeLayer;
    }

    // ── Format dropdown: handle "No Code" removal and format selection ─────────────
    var fmt = document.getElementById('enm-v2-code-format');
    if (fmt) fmt.addEventListener('change', function () {
      var requestedFmt = fmt.value;
      if (requestedFmt === '') {
        // "No Code" selected: remove any code layer
        var codeLayer = layers.find(function (l) { return isCodeLayer(l); });
        if (codeLayer) removeLayer(codeLayer.id);
      } else {
        // Capture selected format first, then activate code layer. Activating
        // can re-sync panel controls and overwrite <select>.value.
        var codeLayer = getOrActivateCodeLayer();
        var is1D = CODE_FORMATS_1D.indexOf(requestedFmt) !== -1;
        if (!codeLayer) {
          addCodeLayer(is1D ? 'barcode-1d' : 'barcode-2d');
          codeLayer = getOrActivateCodeLayer();
        }

        if (codeLayer) {
          // Update existing/new layer's format and infer type.
          var prevType = codeLayer.type;
          codeLayer.format = requestedFmt;
          codeLayer.type = is1D ? 'barcode-1d' : 'barcode-2d';
          if (prevType !== codeLayer.type) {
            if (codeLayer.type === 'barcode-1d') {
              codeLayer.width  = codeLayer.width  || 1.8;
              codeLayer.height = codeLayer.height || 0.45;
              codeLayer.showText = true;
            } else {
              codeLayer.size = codeLayer.size || 0.6;
              codeLayer.showText = false;
            }
          }
          syncCodePanel();
          renderCanvas();
          buildLayersList();
        }
      }
    });

    // ── Source select (link to text layer or custom) ────────────────────────
    var linkSel = document.getElementById('enm-v2-code-link-sel');
    if (linkSel) linkSel.addEventListener('change', function () {
      var requestedSource = linkSel.value;
      var l = getOrActivateCodeLayer();
      if (!l) return;
      if (requestedSource === 'custom') {
        l.linkedLayerId = null;
        l.contentLinked = false;
      } else {
        var layerId = parseInt(requestedSource.replace('layer-', ''), 10);
        var textLayer = layers.find(function (x) { return x.id === layerId; });
        if (textLayer) {
          l.linkedLayerId = layerId;
          l.contentLinked = true;
          l.content = textLayer.text || '';
        }
      }
      syncCodePanel();
      renderCanvas();
    });

    // ── Custom content input ────────────────────────────────────────────────
    var content = document.getElementById('enm-v2-code-content');
    if (content) content.addEventListener('input', function () {
      var l = getOrActivateCodeLayer();
      if (!l) return;
      l.content = content.value;
      renderCanvas();
    });

    // ── Invert / Box pill buttons ───────────────────────────────────────────
    var invert = document.getElementById('enm-v2-code-invert');
    if (invert) invert.addEventListener('click', function () {
      var l = getOrActivateCodeLayer();
      if (!l) return;
      l.inverted = !l.inverted;
      syncCodePanel();
      renderCanvas();
    });

    var box = document.getElementById('enm-v2-code-box');
    if (box) box.addEventListener('click', function () {
      var l = getOrActivateCodeLayer();
      if (!l) return;
      l.boxed = !l.boxed;
      syncCodePanel();
      renderCanvas();
    });

    // ── Show text (1D only) ────────────────────────────────────────────────
    var showText = document.getElementById('enm-v2-code-showtext');
    if (showText) showText.addEventListener('click', function () {
      var l = getOrActivateCodeLayer();
      if (!l || l.type !== 'barcode-1d') return;
      l.showText = l.showText === false;
      syncCodePanel();
      renderCanvas();
    });
  }

  function loadTemplate(tpl) {
    if (!tpl || !Array.isArray(tpl.layers)) return;
    var keep = layers.filter(function (l) { return !l.template; });
    var loaded = [];
    tpl.layers.forEach(function (sl, idx) {
      var l = Object.assign({}, sl);
      l.id = nextLayerId++;
      l.template = true;
      if (l.visible == null) l.visible = true;
      if (l.type === 'text') {
        l._lineIndex = idx;
        l.font = l.font || 'Arial';
        l.align = l.align || 'center';
        l.size = l.size || 20;
        l.text = l.text || '';
      }
      if (l.type === 'barcode-1d') {
        l.format = l.format || CODE_FORMATS_1D[0];
        l.width = l.width || 1.8;
        l.height = l.height || 0.45;
        if (l.contentLinked == null && l.field) l.contentLinked = true;
      }
      if (l.type === 'barcode-2d') {
        l.format = l.format || CODE_FORMATS_2D[1];
        l.size = l.size || 0.6;
        if (l.contentLinked == null && l.field) l.contentLinked = true;
      }
      loaded.push(l);
    });
    var seenCode = false;
    loaded = loaded.filter(function (l) {
      if (!isCodeLayer(l)) return true;
      if (seenCode) return false;
      seenCode = true;
      return true;
    });
    layers = loaded.concat(keep.filter(function (l) { return l.type !== 'text'; }));
    getTextLayers().forEach(function (tl) { syncLinkedCodesForTextLayer(tl); });
    _currentTemplateId = tpl.id || '';
    activeLayerId = layers.length ? layers[0].id : null;
    buildLineInputs();
    buildLayersList();
    syncCodePanel();
    renderCanvas();
  }

  function initTemplateIfAny() {
    if (!_tagTemplates.length) return;
    var tpl = _tagTemplates[0];
    if (tpl) loadTemplate(tpl);
  }

  // ── Options accordion ─────────────────────────────────────────────────────
  function parseFraction(token) {
    var s=(token||'').replace(/[^0-9.\/\-]/g,'');
    var m=s.match(/^(\d+)-(\d+)\/(\d+)$/); if (m) return +m[1]+ +m[2]/ +m[3];
    var s2=s.match(/^(\d+)\/(\d+)$/); if (s2) return +s2[1]/ +s2[2];
    return parseFloat(s)||0;
  }
  function parseSizeOption(raw) {
    var clean=(raw||'').replace(/[\u2033\u201c\u201d"]/g,'');
    var parts=clean.split(/\s*[xX\u00d7]\s*/);
    if (parts.length>=2){
      var hP=null,wP=null;
      parts.forEach(function(p){var l=p.replace(/[^a-zA-Z]/g,'').toLowerCase();if(l==='h')hP=p;else if(l==='w')wP=p;});
      if (hP&&wP) return {w:parseFraction(wP),h:parseFraction(hP)};
      return {w:parseFraction(parts[1]),h:parseFraction(parts[0])};
    }
    var d=parseFraction(parts[0]); return {w:d,h:d};
  }
  function slugify(str){return (str||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');}
  function mountDisplayToSlug(val){var lc=(val||'').toLowerCase();return MOUNT_DISPLAY_TO_SLUG[lc]||lc.replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');}
  function metalLabelToSlug(label){
    if (!label) return '';
    var hit=METAL_FINISH_OPTIONS.find(function(m){return m.label.toLowerCase()===String(label).toLowerCase();});
    return hit?hit.slug:String(label).toLowerCase().replace(/[\s/]+/g,'-');
  }

  function updatePriceDisplay(variantId) {
    var el=document.getElementById('enm-v2-price'); if (!el) return;
    var v=(_product.variants||[]).find(function(x){return x.id===variantId;});
    if (!v) return;
    var qty=getQty();
    var unitPrice=(v.price||0)/100;
    var totalPrice=unitPrice*qty;
    el.textContent='$'+unitPrice.toFixed(2)+' × '+qty+' = $'+totalPrice.toFixed(2);
  }

  function updateTotalPriceDisplay() {
    var variantId=findCurrentVariantId();
    if (variantId) updatePriceDisplay(variantId);
  }

  function updateSpecFromVariant(variantId) {
    var v=(_product.variants||[]).find(function(x){return x.id===variantId;}); if (!v) return;
    updatePriceDisplay(variantId);
    _textLineCountOverride = resolveTextLineCountOverride(v);
    var useProductDims = productType === 'industrial';
    var w = useProductDims ? (parseFloat(_product.plateWidth) || 0) : (parseFloat(v.plateWidth) || parseFloat(_product.plateWidth) || 0);
    var h = useProductDims ? (parseFloat(_product.plateHeight) || 0) : (parseFloat(v.plateHeight) || parseFloat(_product.plateHeight) || 0);
    if (!w||!h) {
      (v.options||[]).forEach(function(opt){
        if (/[xX\u00d7]/.test(opt)||/^\d/.test(opt)){
          var dims=parseSizeOption(opt);
          if (!w&&dims.w) w=dims.w; if (!h&&dims.h) h=dims.h;
        }
      });
    }
    if (w>0) spec.width=w; if (h>0) spec.height=h;
    spec.type = productType;
    spec.shape=_product.plateShape||'rectangle';
    if (spec.shape && spec.shape !== 'rectangle') spec.type = 'shaped';
    spec.shapeSvg=v.plateSvg||_product.plateSvg||'';
    (v.options||[]).forEach(function(opt){
      var slug=mountDisplayToSlug(opt);
      if (['none','adhesive','2-side-holes','4-corner-holes','rivet','rivet-4'].indexOf(slug)!==-1) spec.mounting=slug;
    });
  }

  function findCurrentVariantId(){
    var form=document.querySelector('.product-form form, form[action="/cart/add"]');
    if (form){var inp=form.querySelector('input[name="id"]');if(inp&&inp.value)return parseInt(inp.value,10)||null;}
    var m=location.search.match(/[?&]variant=(\d+)/);
    if (m) return parseInt(m[1],10)||null;
    var v=(_product.variants||[])[0]; return v?v.id:null;
  }

  function syncToNativePicker(variantId) {
    var v=(_product.variants||[]).find(function(x){return x.id===variantId;});
    var form=document.querySelector('.product-form form, form[action="/cart/add"]');
    if (form){var inp=form.querySelector('input[name="id"]');if(inp){inp.value=variantId;inp.dispatchEvent(new Event('change',{bubbles:true}));}}
    
    // Also directly update main product price if it exists
    if (v) {
      var priceEl=document.querySelector('[id*="price"][role="status"], .price--large, [data-price]');
      if (priceEl) {
        var cents=v.price||0;
        var cents_compare=v.compare_at_price||cents;
        // Try to update price text; format as currency
        var priceText='$'+(cents/100).toFixed(2);
        if (priceEl.textContent !== undefined) {
          // Try to preserve structure if it has child elements
          var priceSpan=priceEl.querySelector('[data-price-amount], .price-item__price, .price-item');
          if (priceSpan) { priceSpan.textContent=priceText; }
          else { priceEl.textContent=priceText; }
        }
      }
    }
    
    var detail={variant:v?{id:v.id,price:v.price,compare_at_price:v.compare_at_price||v.price,available:v.available!==false,options:v.options||[]}:null};
    _suppressVariantChange=true;
    document.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:detail}));
    document.documentElement.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:detail}));
    _suppressVariantChange=false;
  }

  function findVariantFromSelections() {
    var optNames=_product.optionNames||[], variants=_product.variants||[];
    return variants.find(function(v){
      return optNames.every(function(name,i){
        return !_selections.hasOwnProperty(i)||!v.options||(v.options[i]===_selections[i]);
      });
    })||variants[0]||null;
  }

  function onOptionsChange() {
    var matched=findVariantFromSelections();
    if (!matched) return;
    var prevWidth=spec.width, prevHeight=spec.height;
    var prevTextByField = {};
    var prevTextByIndex = {};
    // Deep copy previous text layers before they are replaced
    var prevTextLayers = getTextLayers().map(function(tl) {
      return JSON.parse(JSON.stringify(tl));
    });
    getTextLayers().forEach(function (tl, i) {
      var txt = tl && tl.text ? String(tl.text) : '';
      if (!txt.trim()) return;
      if (tl.field) prevTextByField[tl.field] = txt;
      prevTextByIndex[i] = txt;
    });
    updateSpecFromVariant(matched.id);
    // Metal from variant option
    if (_metalIsVariant) {
      var optNames=_product.optionNames||[];
      optNames.forEach(function(name,i){
        var nl=name.toLowerCase().replace(/[^a-z]/g,'');
        if (nl==='metal'||nl==='metalfinish'||nl==='metalandfinish') {
          var val=_selections[i]||'';
          var mf=METAL_FINISH_OPTIONS.find(function(m){return m.label.toLowerCase()===val.toLowerCase();});
          if (mf) spec.metal=mf.slug;
          else {var sl=slugify(val);if(metalBg[sl])spec.metal=sl;}
        }
      });
    }
    // Corner from variant option
    if (_cornerFromProduct) {
      var optNames2=_product.optionNames||[];
      optNames2.forEach(function(name,i){
        var nl=name.toLowerCase().replace(/[^a-z]/g,'');
        if (nl==='shape'||nl==='corner') spec.corner=slugify(_selections[i]||'square');
      });
    }
    syncToNativePicker(matched.id);

    // Keep industrial template-driven field/label/placeholder definitions across option changes.
    var tpl = getTemplateById(_currentTemplateId) || (_tagTemplates[0] || null);
    if (tpl) {
      loadTemplate(tpl);
      getTextLayers().forEach(function (tl, i) {
        var prev = null;
        if (tl.field) {
          prev = prevTextLayers.find(function(otl) { return otl.field === tl.field; });
        }
        if (!prev) prev = prevTextLayers[i] || null;
        if (prev) {
          if (prev.text && prev.text.trim()) tl.text = prev.text;
          if (prev.font) tl.font = prev.font;
          if (prev.size) tl.size = prev.size;
          tl.align = prev.align || tl.align;
          tl.bold = !!prev.bold;
          tl.italic = !!prev.italic;
          tl.underline = !!prev.underline;
          tl.inverted = !!prev.inverted;
          tl.boxed = !!prev.boxed;
          if (prev.x != null && !isNaN(prev.x)) tl.x = prev.x;
          if (prev.y != null && !isNaN(prev.y)) tl.y = prev.y;
        } else if (prevTextByIndex.hasOwnProperty(i)) {
          tl.text = prevTextByIndex[i];
        }
      });
      getTextLayers().forEach(function (tl) { syncLinkedCodesForTextLayer(tl); });
      buildLineInputs();
      buildLayersList();
      syncCodePanel();
      resizeCanvas();
      return;
    }

    initTextLayers(prevWidth, prevHeight);
    // Restore style flags for each text line by field (if available), else by index
    getTextLayers().forEach(function(tl, i) {
      var match = null;
      // Prefer field match if available
      if (tl.field) {
        match = prevTextLayers.find(function(otl) { return otl.field === tl.field; });
      }
      // Fallback to index match
      if (!match && prevTextLayers[i]) {
        match = prevTextLayers[i];
      }
      if (match) {
        tl.bold = !!match.bold;
        tl.italic = !!match.italic;
        tl.underline = !!match.underline;
        tl.inverted = !!match.inverted;
        tl.boxed = !!match.boxed;
      } else {
        tl.bold = false;
        tl.italic = false;
        tl.underline = false;
        tl.inverted = false;
        tl.boxed = false;
      }
    });
    buildLineInputs();
    resizeCanvas();
  }

  // ── Hydrate saved options (variant + metal) after applyDesignState ───────────
  function hydrateSavedOptions(saved) {
    if (!saved) return;
    var variantId=saved.variantId;
    if (variantId) {
      var v=(_product.variants||[]).find(function(x){return x.id===variantId;});
      if (v&&v.options) {
        // Use selectedOptions if available, otherwise fall back to variant options
        var optionsToUse = saved.selectedOptions || {};
        (_product.optionNames||[]).forEach(function(name,i){
          var optionValue = optionsToUse[name] || v.options[i];
          if (optionValue !== undefined) {
            _selections[i]=optionValue;
            var sel=document.getElementById('enm-v2-opt-sel-'+i);
            if (sel) sel.value=optionValue;
          }
        });
        updateSpecFromVariant(variantId);
        // Apply corner from selections if product has a corner/shape option
        if (_cornerFromProduct) {
          (_product.optionNames||[]).forEach(function(name,i){
            var nl=name.toLowerCase().replace(/[^a-z]/g,'');
            if (nl==='shape'||nl==='corner') {
              // If saved state has a corner, find the option value that matches it
              if (saved.spec && saved.spec.corner) {
                var sel = document.getElementById('enm-v2-opt-sel-'+i);
                if (sel) {
                  // Find the option that slugifies to the saved corner
                  Array.from(sel.options).some(function(opt) {
                    if (slugify(opt.value) === saved.spec.corner) {
                      _selections[i] = opt.value;
                      sel.value = opt.value;
                      return true;
                    }
                  });
                }
              }
              spec.corner = slugify(_selections[i] || 'square');
            }
          });
        }
        syncToNativePicker(variantId);
      }
    }
    if (saved.metal&&!_metalIsVariant&&metalBg[saved.metal]) {
      spec.metal=saved.metal;
      var mSel=document.getElementById('enm-v2-metal-sel');
      if (mSel) mSel.value=saved.metal;
    }
    // Update static corner selector if present and not using dynamic options
    if (!_cornerFromProduct && saved.spec && saved.spec.corner) {
      var cornerSel = document.getElementById('enm-v2-corner-sel');
      if (cornerSel) {
        cornerSel.value = saved.spec.corner;
        spec.corner = saved.spec.corner; // Ensure spec is updated
        renderCanvas(); // Re-render with the restored corner
      }
    }
  }

  function buildOptionsAccordion() {
    var container=document.getElementById('enm-v2-options-body'); if (!container) return;
    container.innerHTML=''; _cornerFromProduct=false; _metalIsVariant=false;
    var optNames=_product.optionNames||[], variants=_product.variants||[];
    if (!optNames.length||!variants.length) return;
    _metalIsVariant=optNames.some(function(n){var nl=n.toLowerCase().replace(/[^a-z]/g,'');return nl==='metal'||nl==='metalfinish'||nl==='metalandfinish';});

    function uniqueVals(idx){var seen={},vals=[];variants.forEach(function(v){var val=v.options&&v.options[idx]||'';if(val&&!seen[val]){seen[val]=true;vals.push(val);}});return vals;}
    function availableVals(idx){var avail={};variants.forEach(function(v){var val=v.options&&v.options[idx]||'';if(val&&v.available!==false)avail[val]=true;});return avail;}

    optNames.forEach(function(optName,i){
      var vals=uniqueVals(i); if (!vals.length) return;
      var avail=availableVals(i);
      var nameLC=optName.toLowerCase().replace(/[^a-z]/g,'');
      if (nameLC==='shape'||nameLC==='corner') _cornerFromProduct=true;

      var group=document.createElement('div'); group.className='enm-v2__opt-group';
      var selId='enm-v2-opt-sel-'+i;
      var lbl=document.createElement('label'); lbl.className='enm-v2__opt-label'; lbl.textContent=optName; lbl.htmlFor=selId;
      group.appendChild(lbl);

      var sel=document.createElement('select'); sel.className='enm-v2__opt-sel'; sel.id=selId; sel.dataset.optIdx=i;
      var firstAvail='';
      vals.forEach(function(val){
        var opt=document.createElement('option'); opt.value=val; opt.textContent=val+((!avail[val])?' (unavailable)':''); opt.disabled=!avail[val];
        if (!avail[val]&&!opt.disabled) opt.disabled=true;
        if (!firstAvail&&avail[val]) firstAvail=val;
        sel.appendChild(opt);
      });
      // Set current selection
      if (!_selections.hasOwnProperty(i)) { _selections[i]=firstAvail; }
      sel.value=_selections[i]||firstAvail;
      sel.addEventListener('change',function(){ _selections[i]=sel.value; onOptionsChange(); });
      group.appendChild(sel); container.appendChild(group);
    });

    // Inject Metal & Finish dropdown if not a variant option and product is not shaped.
    // Industrial tags use default_metal as the authoritative source when present.
    if (_product.defaultMetal) {
      var defaultMetalSlug = metalLabelToSlug(_product.defaultMetal);
      if (defaultMetalSlug && metalBg[defaultMetalSlug]) spec.metal = defaultMetalSlug;
    }
    if (!_metalIsVariant && spec.type !== 'shaped' && !(productType === 'industrial' && _product.defaultMetal)) {
      if (_product.defaultMetal) {
        var dMetal = metalLabelToSlug(_product.defaultMetal);
        if (dMetal && metalBg[dMetal]) spec.metal = dMetal;
      }
      var mg=document.createElement('div'); mg.className='enm-v2__opt-group';
      var mSelId='enm-v2-metal-sel';
      var ml=document.createElement('label'); ml.className='enm-v2__opt-label'; ml.textContent='Metal & Finish'; ml.htmlFor=mSelId;
      mg.appendChild(ml);
      var mSel=document.createElement('select'); mSel.className='enm-v2__opt-sel'; mSel.id=mSelId;
      METAL_FINISH_OPTIONS.forEach(function(mf,mi){
        var opt=document.createElement('option'); opt.value=mf.slug; opt.textContent=mf.label;
        if (spec.metal===mf.slug || (mi===0 && !spec.metal)) {
          opt.selected=true;
          spec.metal=mf.slug;
        }
        mSel.appendChild(opt);
      });
      mSel.addEventListener('change',function(){ spec.metal=mSel.value; renderCanvas(); });
      mg.appendChild(mSel); container.appendChild(mg);
    }

    // Mounting defaults: if mounting is not a Shopify option, honor product default_mounting metafield (all product types)
    var hasMountingOption = (_product.optionNames||[]).some(function(name){ return name.toLowerCase().replace(/[^a-z]/g,'') === 'mounting'; });
    if (!hasMountingOption && _product.defaultMounting) {
      spec.mounting = mountDisplayToSlug(_product.defaultMounting) || _product.defaultMounting;
    }

    // Inject static Corner selector if no corner/shape option exists and product is rectangular or memorial.
    if (!_cornerFromProduct && (spec.type === 'rectangular' || spec.type === 'memorial')) {
      if (_product.defaultCorner) spec.corner = _product.defaultCorner;
      var cg = document.createElement('div'); cg.className = 'enm-v2__opt-group';
      var cSelId = 'enm-v2-corner-sel';
      var cl = document.createElement('label'); cl.className = 'enm-v2__opt-label'; cl.textContent = 'Corner Style'; cl.htmlFor = cSelId;
      cg.appendChild(cl);
      var cSel = document.createElement('select'); cSel.className = 'enm-v2__opt-sel'; cSel.id = cSelId;
      var cornerOptions = [
        { value: 'square', label: 'Square' },
        { value: 'rounded', label: 'Rounded' },
        { value: 'notched', label: 'Notched' },
        { value: 'scallop', label: 'Scallop' },
        { value: 'chamfer', label: 'Chamfer' }
      ];
      cornerOptions.forEach(function(co, ci) {
        var opt = document.createElement('option'); opt.value = co.value; opt.textContent = co.label;
        // Disable scallop for very thin plates
        if (co.value === 'scallop' && spec.height < 0.5) opt.disabled = true;
        if (ci === 0) { opt.selected = true; spec.corner = co.value; }
        cSel.appendChild(opt);
      });
      // Set current selection
      cSel.value = spec.corner;
      cSel.addEventListener('change', function() { spec.corner = cSel.value; renderCanvas(); });
      cg.appendChild(cSel); container.appendChild(cg);
    }
  }

  // ── Clipart picker ────────────────────────────────────────────────────────
  var _activeClipartCat=null;

  function buildClipartPicker() {
    var CLIPARTS=window.ENM_CLIPARTS; if (!CLIPARTS) return;
    var tabsWrap=document.getElementById('enm-v2-clipart-tabs');
    var gridWrap=document.getElementById('enm-v2-clipart-grid');
    if (!tabsWrap||!gridWrap) return;
    var cats=[];
    Object.keys(CLIPARTS).forEach(function(id){var cat=CLIPARTS[id].category||'General';if(cats.indexOf(cat)===-1)cats.push(cat);});
    tabsWrap.innerHTML='';
    cats.forEach(function(cat,ci){
      var btn=document.createElement('button');
      btn.type='button'; btn.className='enm-v2__tab'+(ci===0?' enm-v2__tab--active':'');
      btn.textContent=cat; btn.dataset.cat=cat;
      btn.addEventListener('click',function(){
        _activeClipartCat=cat;
        tabsWrap.querySelectorAll('.enm-v2__tab').forEach(function(b){b.classList.toggle('enm-v2__tab--active',b===btn);});
        buildClipartGrid(cat);
      });
      tabsWrap.appendChild(btn);
    });
    if (cats.length){_activeClipartCat=cats[0];buildClipartGrid(cats[0]);}
  }

  function buildClipartGrid(cat) {
    var CLIPARTS=window.ENM_CLIPARTS;
    var gridWrap=document.getElementById('enm-v2-clipart-grid'); if (!gridWrap||!CLIPARTS) return;
    gridWrap.innerHTML='';
    var activeIds=layers.filter(function(l){return l.type==='clipart';}).map(function(l){return l.clipartId;});
    Object.keys(CLIPARTS).forEach(function(id){
      var art=CLIPARTS[id];
      if ((art.category||'General')!==cat) return;
      var cell=document.createElement('div');
      cell.className='enm-v2__clipart-cell'+(activeIds.indexOf(id)!==-1?' enm-v2__clipart-cell--active':'');
      cell.title=art.label||id; cell.dataset.id=id;
      if (art.pathData) {
        var vbMinX=(art.vbCx-art.vbW/2).toFixed(3), vbMinY=(art.vbCy-art.vbH/2).toFixed(3);
        cell.innerHTML='<svg viewBox="'+vbMinX+' '+vbMinY+' '+art.vbW.toFixed(3)+' '+art.vbH.toFixed(3)+'" style="width:76%;height:76%;display:block;margin:auto;" xmlns="http://www.w3.org/2000/svg"><path d="'+art.pathData+'" fill="currentColor"/></svg>';
      } else {
        var tc=document.createElement('canvas'); tc.width=tc.height=40;
        var tCtx=tc.getContext('2d'); tCtx.fillStyle='#333';
        if (art.draw){art.draw(tCtx,20,20,14);tCtx.fill();}
        cell.appendChild(tc);
      }
      cell.addEventListener('click',function(){
        addClipartLayer(id);
        buildClipartGrid(cat);
      });
      gridWrap.appendChild(cell);
    });
  }

  // ── Capture PNG ───────────────────────────────────────────────────────────
  function capturePlatePng() {
    var W=pw(), H=ph();
    var oc=document.createElement('canvas');
    oc.width=Math.round(W*DPR); oc.height=Math.round(H*DPR);
    var oCtx=oc.getContext('2d'); oCtx.scale(DPR,DPR);
    var savedCtx=ctx, savedCanvas=canvas;
    ctx=oCtx; canvas=oc; _capturingClean=true;
    renderCanvas();
    _capturingClean=false; ctx=savedCtx; canvas=savedCanvas;
    try{return oc.toDataURL('image/png',0.92).replace(/^data:image\/png;base64,/,'');}catch(e){return '';}
  }

  // ── Build / apply design state ────────────────────────────────────────────
  function buildDesignState(variantId) {
    var textLayers=getTextLayers();
    var clipartLayers=layers.filter(function(l){return l.type==='clipart';});
    var codeLayers=layers.filter(function (l) { return isCodeLayer(l); });
    var specialInstr='';
    var sInp=document.getElementById('enm-v2-special-instructions'); if (sInp) specialInstr=sInp.value.trim();
    
    // Collect selected options
    var selectedOptions = {};
    (_product.optionNames||[]).forEach(function(name,i){
      var sel=document.getElementById('enm-v2-opt-sel-'+i);
      if (sel && sel.value) {
        selectedOptions[name] = sel.value;
      }
    });
    
    return {
      v:2, variantId:variantId, productHandle:_product.handle||'', metal:spec.metal,
      selectedOptions:selectedOptions,
      spec:{
        type:spec.type,
        width:spec.width,
        height:spec.height,
        corner:spec.corner,
        shape:spec.shape,
        shapeSvg:spec.shapeSvg,
        mounting:spec.mounting,
        borderPng:spec.borderPng,
        borderMargin:spec.borderMargin
      },
      text:{
        font:(textLayers[0]&&textLayers[0].font)||'Arial',
        align:(textLayers[0]&&textLayers[0].align)||'center',
        lines:textLayers.map(function(l){return{text:l.text,font:l.font,align:l.align,bold:!!l.bold,italic:!!l.italic,underline:!!l.underline,size:l.size,x:l.x,y:l.y,flipX:!!l.flipX,flipY:!!l.flipY};})
      },
      image:{
        cliparts:clipartLayers.map(function(l){return{clipartId:l.clipartId,size:l.clipartSize,x:l.x,y:l.y,flipX:!!l.flipX,flipY:!!l.flipY};})
      },
      industrial: {
        templateId: _currentTemplateId || '',
        layers: layers.map(function (l) {
          return {
            id: l.id,
            type: l.type,
            visible: l.visible !== false,
            field: l.field || '',
            template: !!l.template,
            x: l.x || 0,
            y: l.y || 0,
            text: l.text || '',
            label: l.label || '',
            placeholder: l.placeholder || '',
            font: l.font || 'Arial',
            align: l.align || 'center',
            size: l.size || 0,
            bold: !!l.bold,
            italic: !!l.italic,
            underline: !!l.underline,
            clipartId: l.clipartId || '',
            clipartSize: l.clipartSize || 0,
            format: l.format || '',
            width: l.width || 0,
            height: l.height || 0,
            content: l.content || '',
            contentLinked: l.contentLinked !== false,
            linkedLayerId: l.linkedLayerId || null,
            inverted: !!l.inverted,
            boxed: !!l.boxed,
            showText: l.showText !== false,
            flipX: !!l.flipX,
            flipY: !!l.flipY
          };
        }),
        codeCount: codeLayers.length
      },
      specialInstructions:specialInstr,
      qty:getQty()
    };
  }

  function applyDesignState(saved) {
    if (!saved) return;
    // If the saved state contains plate dimensions, restore them here first.
    if (saved.spec) {
      spec.width = parseFloat(saved.spec.width) || spec.width;
      spec.height = parseFloat(saved.spec.height) || spec.height;
      if (saved.spec.corner) spec.corner = saved.spec.corner;
      if (saved.spec.shape) spec.shape = saved.spec.shape;
      if (saved.spec.shapeSvg) spec.shapeSvg = saved.spec.shapeSvg;
      if (saved.spec.type) spec.type = saved.spec.type;
      if (saved.spec.borderPng) spec.borderPng = saved.spec.borderPng;
      if (saved.spec.borderMargin != null) spec.borderMargin = parseFloat(saved.spec.borderMargin) || 0;
      if (spec.borderPng) loadBorderImage(spec.borderPng, renderCanvas);
    }
    var textLayers=getTextLayers();
    var fromV1=false;

    if (!saved.v&&Array.isArray(saved.layers)) {
      // V1 format
      fromV1=true;
      var v1text=saved.layers.filter(function(l){return l.type==='text'&&l.text;}).sort(function(a,b){return(a.y||0)-(b.y||0);});
      v1text.forEach(function(vl,i){
        if (textLayers[i]){textLayers[i].text=vl.text||'';textLayers[i].font=vl.font||'Arial';
          textLayers[i].align=vl.align||'center';textLayers[i].bold=!!vl.bold;textLayers[i].italic=!!vl.italic;textLayers[i].underline=!!vl.underline;}
      });
      var v1arts=saved.layers.filter(function(l){return l.type==='clipart'&&l.clipartId;});
      layers=layers.filter(function(l){return l.type!=='clipart';});
      v1arts.forEach(function(al){layers.push({id:nextLayerId++,type:'clipart',clipartId:al.clipartId,clipartSize:al.clipartSize||1,x:al.x||0,y:al.y||0});});
      if (saved.spec){if(saved.spec.metal&&metalBg[saved.spec.metal])spec.metal=saved.spec.metal;if(saved.spec.corner)spec.corner=saved.spec.corner;}

    } else if (saved.v===2&&saved.text) {
      // V2 grouped format
      (saved.text.lines||[]).forEach(function(sl,i){
        if (!textLayers[i]) return;
        textLayers[i].text=sl.text||'';
        if (sl.font) textLayers[i].font=sl.font;
        if (sl.align) textLayers[i].align=sl.align;
        textLayers[i].bold=!!sl.bold; textLayers[i].italic=!!sl.italic; textLayers[i].underline=!!sl.underline;
        if (sl.size) textLayers[i].size=sl.size;
        if (sl.x!=null) textLayers[i].x=sl.x; if (sl.y!=null) textLayers[i].y=sl.y;
        textLayers[i].flipX=!!sl.flipX; textLayers[i].flipY=!!sl.flipY;
      });
      // New multi-clipart format
      var savedArts=(saved.image&&saved.image.cliparts)||[];
      // Backward compat: old single clipartId format
      if (!savedArts.length&&saved.image&&saved.image.clipartId) {
        savedArts=[{clipartId:saved.image.clipartId,size:saved.image.size||1,x:saved.image.x||0,y:saved.image.y||0}];
      }
      layers=layers.filter(function(l){return l.type!=='clipart' && !isCodeLayer(l);});
      savedArts.forEach(function(sa){layers.push({id:nextLayerId++,type:'clipart',clipartId:sa.clipartId,clipartSize:sa.size||1,x:sa.x||0,y:sa.y||0,flipX:!!sa.flipX,flipY:!!sa.flipY});});
      if (saved.metal&&metalBg[saved.metal]) spec.metal=saved.metal;

      if (saved.industrial && Array.isArray(saved.industrial.layers)) {
        layers = saved.industrial.layers.map(function (sl) {
          var l = Object.assign({}, sl);
          l.id = nextLayerId++;
          if (!l.type) l.type = 'text';
          if (l.visible == null) l.visible = true;
          l.flipX = !!l.flipX;
          l.flipY = !!l.flipY;
          return l;
        });
        var codeSeen = false;
        layers = layers.filter(function (l) {
          if (!isCodeLayer(l)) return true;
          if (codeSeen) return false;
          codeSeen = true;
          return true;
        });

        // Normalize text ordering/line indices so line-input bindings map to
        // the restored layers (not stale pre-resume placeholders).
        var textIdx = 0;
        layers.forEach(function (l) {
          if (l.type === 'text') {
            l._lineIndex = textIdx;
            textIdx++;
          }
        });

        // For non-template designs, keep blank text slots available on resume
        // so users can add lines again (customizer-like behavior).
        var hasTemplateText=layers.some(function(l){return l.type==='text' && l.template===true;});
        if (!hasTemplateText) {
          var desired=maxLines();
          for (var ti=textIdx;ti<desired;ti++) {
            var ty=desired===1?0:(ti-(desired-1)/2)*spec.height/(desired+1);
            layers.push({
              id:nextLayerId++,
              type:'text',
              text:'',
              font:'Arial',
              size:Math.max(10,Math.min(48,Math.round(spec.height*PPI/(desired*1.6)))),
              align:'center',
              bold:false,
              italic:false,
              underline:false,
              x:0,
              y:ty,
              flipX:false,
              flipY:false,
              _lineIndex:ti
            });
          }
        }

        _currentTemplateId = saved.industrial.templateId || '';
      }

    } else if (saved.v===2&&Array.isArray(saved.lines)) {
      // V2 flat (legacy)
      saved.lines.forEach(function(sl,i){if(textLayers[i]){textLayers[i].text=sl.text||'';textLayers[i].font=saved.font||'Arial';textLayers[i].align=saved.align||'center';}});
      if (saved.clipartId){layers=layers.filter(function(l){return l.type!=='clipart';});layers.push({id:nextLayerId++,type:'clipart',clipartId:saved.clipartId,clipartSize:1,x:0,y:0});}
    } else { return; }

    // Rebuild line inputs from the restored live layers so edit-mode text
    // events update current layers instead of stale pre-resume references.
    buildLineInputs();

    // Restore special instructions
    if (saved.specialInstructions) {
      var sInp=document.getElementById('enm-v2-special-instructions');
      if (sInp) sInp.value=saved.specialInstructions;
    }

    // Restore selected options
    if (saved.selectedOptions) {
      (_product.optionNames||[]).forEach(function(name,i){
        if (saved.selectedOptions[name]) {
          var sel=document.getElementById('enm-v2-opt-sel-'+i);
          if (sel) sel.value=saved.selectedOptions[name];
        }
      });
    }

    // Restore quantity (if included in state or in URL)
    var qInp=document.getElementById('enm-v2-qty');
    if (qInp && saved.qty != null) {
      var qVal=parseInt(saved.qty,10);
      if (!isNaN(qVal)&&qVal>=1&&qVal<=99) qInp.value=qVal;
    }

    if (fromV1){var banner=document.getElementById('enm-v2-migrate-banner');if(banner)banner.style.display='';}
    getTextLayers().forEach(function (tl) { syncLinkedCodesForTextLayer(tl); });

    // Ensure an editable text layer is active after restore.
    var active=getActiveLayer();
    if (!active || active.type!=='text') {
      var firstText=getTextLayers()[0]||null;
      activeLayerId=firstText?firstText.id:(layers.length?layers[0].id:null);
    }

    syncActiveLayerControls();
    buildLayersList();
    syncCodePanel();
    resizeCanvas();
  }

  // ── ATC ───────────────────────────────────────────────────────────────────
  var ENM_VERCEL_UPLOAD='https://shopify-vercel-integration.vercel.app/api/upload-enm';

  function uploadBlob(filename,content,contentType){
    return fetch(ENM_VERCEL_UPLOAD,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({filename:filename,content:content,contentType:contentType})})
      .then(function(r){return r.json();}).then(function(d){return d.url||null;}).catch(function(){return null;});
  }

  function escapeXmlAttr(value){
    return String(value==null?'':value)
      .replace(/&/g,'&amp;')
      .replace(/"/g,'&quot;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;');
  }

  function fmtLbrnNum(n){
    var v=Number(n);
    if (!isFinite(v)) v=0;
    return String(Math.round(v*1000000)/1000000);
  }

  function rotatePoint(x,y,a){
    var ca=Math.cos(a), sa=Math.sin(a);
    return [x*ca-y*sa,x*sa+y*ca];
  }

  function cubicPoint(p0,p1,p2,p3,t){
    var mt=1-t;
    return mt*mt*mt*p0+3*mt*mt*t*p1+3*mt*t*t*p2+t*t*t*p3;
  }

  function quadPoint(p0,p1,p2,t){
    var mt=1-t;
    return mt*mt*p0+2*mt*t*p1+t*t*p2;
  }

  function parseSvgPathToPolylines(pathData){
    if (!pathData) return [];
    var tokens=String(pathData).match(/[a-zA-Z]|[-+]?(?:\d*\.\d+|\d+)(?:[eE][-+]?\d+)?/g)||[];
    var i=0, cmd='';
    var cx=0, cy=0, sx=0, sy=0, cpx=0, cpy=0, qpx=0, qpy=0;
    var curr=[], paths=[];

    function isNum(t){ return t!=null && !/^[a-zA-Z]$/.test(t); }
    function nextNum(){ var n=parseFloat(tokens[i++]||'0'); return isFinite(n)?n:0; }
    function pushPoint(x,y){ curr.push([x,y]); cx=x; cy=y; }
    function endPath(closed){
      if (curr.length>1) paths.push({pts:curr.slice(),closed:!!closed});
      curr=[];
    }

    while(i<tokens.length){
      if (/^[a-zA-Z]$/.test(tokens[i])) cmd=tokens[i++];
      if (!cmd) break;
      var rel=(cmd===cmd.toLowerCase());

      if (cmd==='M' || cmd==='m'){
        var mx=nextNum(), my=nextNum();
        if (rel){mx+=cx; my+=cy;}
        if (curr.length) endPath(false);
        pushPoint(mx,my); sx=mx; sy=my;
        while(isNum(tokens[i]) && isNum(tokens[i+1])){
          var lx=nextNum(), ly=nextNum();
          if (rel){lx+=cx; ly+=cy;}
          pushPoint(lx,ly);
        }
        continue;
      }

      if (cmd==='L' || cmd==='l'){
        while(isNum(tokens[i]) && isNum(tokens[i+1])){
          var x=nextNum(), y=nextNum();
          if (rel){x+=cx; y+=cy;}
          pushPoint(x,y);
        }
        continue;
      }

      if (cmd==='H' || cmd==='h'){
        while(isNum(tokens[i])){
          var hx=nextNum();
          if (rel) hx+=cx;
          pushPoint(hx,cy);
        }
        continue;
      }

      if (cmd==='V' || cmd==='v'){
        while(isNum(tokens[i])){
          var vy=nextNum();
          if (rel) vy+=cy;
          pushPoint(cx,vy);
        }
        continue;
      }

      if (cmd==='C' || cmd==='c'){
        while(isNum(tokens[i]) && isNum(tokens[i+5])){
          var x1=nextNum(), y1=nextNum(), x2=nextNum(), y2=nextNum(), x3=nextNum(), y3=nextNum();
          if (rel){x1+=cx; y1+=cy; x2+=cx; y2+=cy; x3+=cx; y3+=cy;}
          for (var t=1;t<=12;t++){
            var tt=t/12;
            pushPoint(cubicPoint(cx,x1,x2,x3,tt),cubicPoint(cy,y1,y2,y3,tt));
          }
          cpx=x2; cpy=y2;
        }
        continue;
      }

      if (cmd==='S' || cmd==='s'){
        while(isNum(tokens[i]) && isNum(tokens[i+3])){
          var rx1=cx, ry1=cy;
          if (/[CcSs]$/.test(cmd)) { rx1=2*cx-cpx; ry1=2*cy-cpy; }
          var sx2=nextNum(), sy2=nextNum(), sx3=nextNum(), sy3=nextNum();
          if (rel){sx2+=cx; sy2+=cy; sx3+=cx; sy3+=cy;}
          for (var st=1;st<=12;st++){
            var sst=st/12;
            pushPoint(cubicPoint(cx,rx1,sx2,sx3,sst),cubicPoint(cy,ry1,sy2,sy3,sst));
          }
          cpx=sx2; cpy=sy2;
        }
        continue;
      }

      if (cmd==='Q' || cmd==='q'){
        while(isNum(tokens[i]) && isNum(tokens[i+3])){
          var qx1=nextNum(), qy1=nextNum(), qx2=nextNum(), qy2=nextNum();
          if (rel){qx1+=cx; qy1+=cy; qx2+=cx; qy2+=cy;}
          for (var qt=1;qt<=10;qt++){
            var qqt=qt/10;
            pushPoint(quadPoint(cx,qx1,qx2,qqt),quadPoint(cy,qy1,qy2,qqt));
          }
          qpx=qx1; qpy=qy1;
        }
        continue;
      }

      if (cmd==='T' || cmd==='t'){
        while(isNum(tokens[i]) && isNum(tokens[i+1])){
          var tqx=2*cx-qpx, tqy=2*cy-qpy;
          var tx=nextNum(), ty=nextNum();
          if (rel){tx+=cx; ty+=cy;}
          for (var tt2=1;tt2<=10;tt2++){
            var ttt=tt2/10;
            pushPoint(quadPoint(cx,tqx,tx,ttt),quadPoint(cy,tqy,ty,ttt));
          }
          qpx=tqx; qpy=tqy;
        }
        continue;
      }

      if (cmd==='A' || cmd==='a'){
        while(isNum(tokens[i]) && isNum(tokens[i+6])){
          i+=5;
          var ax=nextNum(), ay=nextNum();
          if (rel){ax+=cx; ay+=cy;}
          pushPoint(ax,ay);
        }
        continue;
      }

      if (cmd==='Z' || cmd==='z'){
        endPath(true);
        cx=sx; cy=sy;
        continue;
      }
    }

    if (curr.length>1) endPath(false);
    return paths;
  }

  function pushLbrnPath(out,cutIndex,pointsMm,closed){
    if (!pointsMm || pointsMm.length<2) return;
    out.push('    <Shape Type="Path" CutIndex="'+cutIndex+'">');
    out.push('        <XForm>1 0 0 1 0 0</XForm>');
    pointsMm.forEach(function(p){
      out.push('        <V vx="'+fmtLbrnNum(p[0])+'" vy="'+fmtLbrnNum(p[1])+'"/>');
    });
    for (var i=0;i<pointsMm.length-1;i++) out.push('        <P T="L" p0="'+i+'" p1="'+(i+1)+'"/>');
    if (closed) out.push('        <P T="L" p0="'+(pointsMm.length-1)+'" p1="0"/>');
    out.push('    </Shape>');
  }

  function buildMinimalLbrn(stateObj){
    var s=(stateObj&&stateObj.spec)||spec||{};
    var widthIn=Math.max(0.1,parseFloat(s.width)||1);
    var heightIn=Math.max(0.1,parseFloat(s.height)||1);
    var mmW=widthIn*25.4;
    var mmH=heightIn*25.4;
    var textLines=((stateObj&&stateObj.text&&stateObj.text.lines)||[]).filter(function(l){return l&&l.text&&String(l.text).trim();});
    var cliparts=((stateObj&&stateObj.image&&stateObj.image.cliparts)||[]).filter(function(c){return c&&c.clipartId;});
    var codeLayers=((stateObj&&stateObj.industrial&&stateObj.industrial.layers)||[]).filter(function(l){
      return l && (l.type==='barcode-1d' || l.type==='barcode-2d') && l.visible!==false;
    });
    var CLIPARTS=window.ENM_CLIPARTS||{};

    function emitRect(out,yOffMm){
      out.push('    <Shape Type="Rect" CutIndex="0" W="'+fmtLbrnNum(mmW)+'" H="'+fmtLbrnNum(mmH)+'" Cr="0">');
      out.push('        <XForm>1 0 0 1 0 '+fmtLbrnNum(yOffMm)+'</XForm>');
      out.push('    </Shape>');
    }

    function emitLiveText(out,cutIndex,yOffMm){
      textLines.forEach(function(l){
        var text=String(l.text||'').trim();
        if (!text) return;
        var fontName=String(l.font||'Arial').replace(/[\",]/g,'');
        var align=(l.align||'center');
        var ah=align==='left'?0:align==='right'?2:1;
        var xIn=align==='left'?(-widthIn*0.45):(align==='right'?(widthIn*0.45):0);
        xIn+=(parseFloat(l.x)||0);
        var yIn=(parseFloat(l.y)||0);
        var xMm=xIn*25.4;
        var yMm=-(yIn*25.4)+yOffMm;
        var hMm=((parseFloat(l.size)||16)/PPI)*25.4;
        if (!isFinite(hMm)||hMm<=0) hMm=3;
        if (hMm<2) hMm=2;
        out.push('    <Shape Type="Text" CutIndex="'+cutIndex+'" Font="'+escapeXmlAttr(fontName)+',-1,4096,5,400,0,0,0,0,0" Str="'+escapeXmlAttr(text)+'" H="'+fmtLbrnNum(hMm)+'" LS="0" LnS="0" Ah="'+ah+'" Av="2" Weld="0" HasBackupPath="0">');
        out.push('        <XForm>1 0 0 1 '+fmtLbrnNum(xMm)+' '+fmtLbrnNum(yMm)+'</XForm>');
        out.push('    </Shape>');
      });
    }

    function emitClipartPaths(out,cutIndex,yOffMm){
      cliparts.forEach(function(c){
        var art=CLIPARTS[c.clipartId];
        if (!art || !art.pathData || !art.vbW || !art.vbH) return;
        var r=((parseFloat(c.size)||1)*PPI)/2;
        var maxDim=Math.max(art.vbW,art.vbH);
        if (!maxDim) return;
        var sPx=(r*2)/maxDim;
        var cx=(parseFloat(c.x)||0)*PPI;
        var cy=(parseFloat(c.y)||0)*PPI;
        var rot=parseFloat(c.rotation)||0;
        var flipX=c.flipX?-1:1;
        var flipY=c.flipY?-1:1;
        var polys=parseSvgPathToPolylines(art.pathData);
        polys.forEach(function(poly){
          var pts=[];
          for (var pi=0;pi<poly.pts.length;pi++){
            var p=poly.pts[pi];
            var px=(p[0]-art.vbCx)*sPx;
            var py=(p[1]-art.vbCy)*sPx;
            px*=flipX; py*=flipY;
            if (rot){ var rp=rotatePoint(px,py,rot); px=rp[0]; py=rp[1]; }
            var absX=cx+px;
            var absY=cy+py;
            pts.push([absX/PPI*25.4,-(absY/PPI*25.4)+yOffMm]);
          }
          pushLbrnPath(out,cutIndex,pts,!!poly.closed);
        });
      });
    }

    function lbrnBarCodeTypeForLayer(layer){
      var f=String((layer&&layer.format)||'').toUpperCase();
      if (f==='CODE128') return 20;
      if (f==='CODE93') return 25;
      if (f==='QRCODE') return 58;
      if (f==='DATAMATRIX') return 71;
      // Legacy fallback: old saved CODE39 layers export as Code128.
      if (f==='CODE39') return 20;
      return null;
    }

    function emitIndustrialBarcodes(out,cutIndex,yOffMm){
      codeLayers.forEach(function(l){
        var barType=lbrnBarCodeTypeForLayer(l);
        if (!barType) return;

        var is2d=(l.type==='barcode-2d');
        var wIn=is2d?(parseFloat(l.size)||0.6):(parseFloat(l.width)||1.8);
        var hIn=is2d?(parseFloat(l.size)||0.6):(parseFloat(l.height)||0.45);
        var desiredWMm=Math.max(0.1,wIn)*25.4;
        var desiredHMm=Math.max(0.1,hIn)*25.4;
        var xMm=(parseFloat(l.x)||0)*25.4;
        var yMm=-(parseFloat(l.y)||0)*25.4+yOffMm;
        var content=String(l.content||'').trim();
        if (!content) content=is2d?'ENM-001':'12345';
        if (!is2d && String((l&&l.format)||'').toUpperCase()==='CODE39') content=content.toUpperCase();

        // LightBurn barcode objects use internal native dimensions. Build a native
        // barcode via bwip-js and scale with XForm so final physical size matches
        // the canvas layer width/height.
        var shapeW=desiredWMm;
        var shapeH=desiredHMm;
        var sx=1;
        var sy=1;
        if (typeof bwipjs!=='undefined') {
          try {
            var oc=document.createElement('canvas');
            var bcid=BCID_MAP[l.format] || (is2d?'datamatrix':'code128');
            bwipjs.toCanvas(oc, {
              bcid: bcid,
              text: content,
              scale: 2,
              height: 10,
              includetext: is2d ? false : (l.showText !== false),
              paddingwidth: 0,
              paddingheight: 0
            });
            if (oc.width>0 && oc.height>0) {
              shapeW=oc.width;
              shapeH=oc.height;
              sx=desiredWMm/shapeW;
              sy=desiredHMm/shapeH;
            }
          } catch(e) {}
        }

        out.push('    <Shape Type="BarCode" CutIndex="'+cutIndex+'" W="'+fmtLbrnNum(shapeW)+'" H="'+fmtLbrnNum(shapeH)+'" Content="'+escapeXmlAttr(content)+'" BarCodeType="'+barType+'"'+(is2d?'':' ShowText="'+(l.showText===false?0:1)+'"')+' ProcessControlChars="0" InputMode="0"'+(barType===71?' Option_3="100"':'')+(barType===58?' Option_1="-1"':'')+'>');
        out.push('        <XForm>'+fmtLbrnNum(sx)+' 0 0 '+fmtLbrnNum(sy)+' '+fmtLbrnNum(xMm)+' '+fmtLbrnNum(yMm)+'</XForm>');
        out.push('    </Shape>');
      });
    }

    var out=[];
    out.push('<?xml version="1.0" encoding="UTF-8"?>');
    out.push('<LightBurnProject AppVersion="2.0.05" DeviceName="No Machine" FormatVersion="0" MaterialHeight="0" MirrorX="False" MirrorY="False">');
    out.push('    <CutSetting type="Cut"><index Value="0"/><name Value="C00"/><maxPower Value="20"/><maxPower2 Value="20"/><speed Value="100"/><priority Value="0"/></CutSetting>');
    out.push('    <CutSetting type="Cut"><index Value="1"/><name Value="C01"/><maxPower Value="20"/><maxPower2 Value="20"/><speed Value="100"/><priority Value="1"/></CutSetting>');

    // Text-object only export (path compare/backup branch disabled by request).
    emitRect(out, 0);
    emitLiveText(out, 1, 0);
    emitClipartPaths(out, 1, 0);
    emitIndustrialBarcodes(out, 1, 0);

    out.push('    <Notes ShowOnLoad="0" Notes="LBRN text-object + barcode export"/>');
    out.push('</LightBurnProject>');
    return Promise.resolve(out.join('\n'));
  }

  var atcBtn=document.getElementById('enm-v2-atc');
  var atcAnotherBtn=document.getElementById('enm-v2-atc-another');
  var atcMsg=document.getElementById('enm-v2-atc-msg');

  function showMsg(text,type){
    if (!atcMsg) return;
    atcMsg.textContent=text; atcMsg.className='enm-v2__atc-msg enm-v2__atc-msg--'+type;
    setTimeout(function(){atcMsg.textContent='';atcMsg.className='enm-v2__atc-msg';},4000);
  }

  function updateCartBadge(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count;});
      document.querySelectorAll('.cart-count-bubble').forEach(function(el){
        el.style.display=cart.item_count?'':'none';
        var sp=el.querySelector('span[aria-hidden]');if(sp)sp.textContent=cart.item_count;
      });
    }).catch(function(){});
  }

  function getQty(){
    var qInp=document.getElementById('enm-v2-qty');
    if (!qInp) return 1;
    var v=parseInt(qInp.value,10);
    return (isNaN(v)||v<1)?1:v;
  }

  function getNativeQty(){
    var nativeQty=document.querySelector('.product-form form input[name="quantity"], form[action="/cart/add"] input[name="quantity"]');
    if (!nativeQty) return null;
    var v=parseInt(nativeQty.value,10);
    return (isNaN(v)||v<1)?null:v;
  }

  function syncNativeQty(v){
    var nativeQty=document.querySelector('.product-form form input[name="quantity"], form[action="/cart/add"] input[name="quantity"]');
    if (!nativeQty) return;
    nativeQty.value=v;
  }

  function setQty(qty){
    var qInp=document.getElementById('enm-v2-qty');
    if (!qInp) return;
    var v=parseInt(qty,10);
    if (isNaN(v)) return;
    v=Math.max(1,Math.min(99,v));
    qInp.value=v;
    syncNativeQty(v);
    updateTotalPriceDisplay();
  }

  function doAddToCart(mode) {
    var variantId = findCurrentVariantId();
    if (!variantId) { showMsg('Please select a product option above.', 'err'); return; }
    var textLayers = layers.filter(function(l) { return l.type === 'text'; }).sort(function(a, b) { return (a._lineIndex || 0) - (b._lineIndex || 0); });
    if (!textLayers[0] || !textLayers[0].text.trim()) { showMsg('Line 1 is required — please enter your text.', 'err'); return; }

    var triggerBtn = mode === 'another' ? atcAnotherBtn : atcBtn;
    if (atcBtn) atcBtn.disabled = true;
    if (atcAnotherBtn) atcAnotherBtn.disabled = true;
    if (triggerBtn) triggerBtn.textContent = 'Saving design…';

    var specialInstr = '';
    var sInp = document.getElementById('enm-v2-special-instructions'); if (sInp) specialInstr = sInp.value.trim();
    var prefix = ((_product.handle || 'design').replace(/[^a-z0-9-]/gi, '-')) + '-' + Date.now();
    var pngData = capturePlatePng();
    var stateObj = buildDesignState(variantId);
    var stateJson = JSON.stringify(stateObj);
    var lbrnPromise = buildMinimalLbrn(stateObj);

    Promise.resolve(lbrnPromise).then(function(lbrnData) {
      return Promise.all([
        pngData ? uploadBlob(prefix + '.png', pngData, 'image/png') : Promise.resolve(null),
        uploadBlob(prefix + '.json', stateJson, 'application/json'),
        uploadBlob(prefix + '.lbrn', lbrnData, 'application/xml')
      ]);
    }).then(function(urls) {
      var previewUrl = urls[0], designStateUrl = urls[1], lbrnUrl = urls[2];
      var props = {};
      var cartQty = getQty();
      // Track saved properties to prevent duplicates
      var savedProps = new Set();
      // NOTE: Variant options (Size, Material, etc.) are now displayed as subtitle under product title
      // in cart, so we don't save them as line item properties. Only save custom options.
      // Save shape/corner options (only if not already saved as variant options above)
      if (_cornerFromProduct) {
        // Dynamic corner/shape options - already saved above as variant options
      } else if (spec.shape === 'rectangle') {
        // Static corner option
        var cornerSel = document.getElementById('enm-v2-corner-sel');
        if (cornerSel && cornerSel.value) {
          var cornerLabel = cornerSel.options[cornerSel.selectedIndex].text;
          var propName = 'Corner Style';
          if (!savedProps.has(propName)) {
            props[propName] = cornerLabel;
            savedProps.add(propName);
          }
        }
      }
      // Save metal & finish (only if not already saved as variant option above)
      if (_metalIsVariant) {
        // Metal is a variant option - already saved above
      } else {
        // Static metal option or product default_metal
        var metalSel = document.getElementById('enm-v2-metal-sel');
        var metalEntry = METAL_FINISH_OPTIONS.find(function(m) { return m.slug === spec.metal; });
        if (!metalEntry && _product.defaultMetal) {
          metalEntry = METAL_FINISH_OPTIONS.find(function(m) { return m.slug === metalLabelToSlug(_product.defaultMetal); }) || null;
        }
        if (metalSel || (productType === 'industrial' && _product.defaultMetal)) {
          if (metalEntry) {
            var propName = 'Metal & Finish';
            if (!savedProps.has(propName)) {
              props[propName] = metalEntry.label;
              savedProps.add(propName);
            }
          }
        }
      }
      // Save mounting (from spec.mounting)
      if (spec.mounting && spec.mounting !== 'none') {
        var mountingLabels = {
          'adhesive': 'Adhesive Backing',
          '2-side-holes': '2 Side Holes',
          '4-corner-holes': '4 Corner Holes'
        };
        if (mountingLabels[spec.mounting]) {
          var propName = 'Mounting';
          if (!savedProps.has(propName)) {
            props[propName] = mountingLabels[spec.mounting];
            savedProps.add(propName);
          }
        }
      }
      // Save text lines with font and style
      textLayers.forEach(function(l, i) {
        if (!l.text) return;
        var lineNum = (l._lineIndex != null ? l._lineIndex : i) + 1;
        var propName = 'Line ' + lineNum;
        if (!savedProps.has(propName)) {
          props[propName] = l.text;
          savedProps.add(propName);
        }
        var styleParts = [];
        if (l.font) styleParts.push(l.font);
        if (l.bold) styleParts.push('Bold');
        if (l.italic) styleParts.push('Italic');
        if (l.underline) styleParts.push('Under');
        if (l.inverted) styleParts.push('Invert');
        if (l.boxed) styleParts.push('Box');
        var stylePropName = '_Line ' + lineNum + ' style';
        props[stylePropName] = styleParts.join('|');
        savedProps.add(stylePropName);
      });
      // Save all cliparts
      var clipartLayers = layers.filter(function(l) { return l.type === 'clipart'; });
      if (clipartLayers.length) {
        clipartLayers.forEach(function(l, i) {
          var propName = 'Clipart ' + (i + 1);
          if (!savedProps.has(propName)) {
            props[propName] = l.clipartId;
            savedProps.add(propName);
          }
        });
      }
      // Save special instructions
      if (specialInstr) {
        var propName = 'Special Instructions';
        if (!savedProps.has(propName)) {
          props[propName] = specialInstr;
          savedProps.add(propName);
        }
      }
      // Save internal properties
      if (previewUrl) props['_preview_url'] = previewUrl;
      if (designStateUrl) props['_design_state_url'] = designStateUrl;
      if (lbrnUrl) props['_lbrn_url'] = lbrnUrl;
      props['_product_handle'] = _product.handle || '';
      props['_is_custom'] = 'true';

      // --- Fix: If editing and variant changed, remove old and add new ---
      if (_editLineItemKey) {
        // Use variant_id from URL for stateless comparison
        var prevVariantId = _editVariantId;
        if (prevVariantId && prevVariantId !== variantId) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: _editLineItemKey, quantity: 0 })
          }).then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: cartQty, properties: props })
            });
          }).then(function(r) { return r.json(); }).then(function(data) {
            if (data.status) { showMsg(data.description || 'Could not update cart.', 'err'); }
            else {
              document.documentElement.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
              updateCartBadge();
              if (mode === 'goto') {
                showMsg('Design updated! Redirecting…', 'ok');
                setTimeout(function() { window.location.href = '/cart'; }, 800);
              } else {
                _editLineItemKey = ''; try { sessionStorage.removeItem('_enm_v2_edit_key'); } catch (e) {}
                showMsg('Cart updated! Ready for another design.', 'ok');
              }
            }
          }).catch(function() { showMsg('Network error. Please try again.', 'err'); })
          .then(function() {
            if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Update cart & Go to Checkout'; }
            if (atcAnotherBtn) { atcAnotherBtn.disabled = false; atcAnotherBtn.textContent = 'Update cart & Design Another'; }
          });
        } else {
          // Same variant, update in place
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: _editLineItemKey, quantity: cartQty, properties: props })
          }).then(function(r) { return r.json(); }).then(function(data) {
            if (data.status) { showMsg(data.description || 'Could not update cart.', 'err'); }
            else {
              document.documentElement.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
              updateCartBadge();
              if (mode === 'goto') {
                showMsg('Design updated! Redirecting…', 'ok');
                setTimeout(function() { window.location.href = '/cart'; }, 800);
              } else {
                var wasEdit = !!_editLineItemKey;
                _editLineItemKey = ''; try { sessionStorage.removeItem('_enm_v2_edit_key'); } catch (e) {}
                showMsg(wasEdit ? 'Cart updated! Ready for another design.' : 'Added to cart! Ready for another design.', 'ok');
              }
            }
          }).catch(function() { showMsg('Network error. Please try again.', 'err'); })
          .then(function() {
            if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Update cart & Go to Checkout'; }
            if (atcAnotherBtn) { atcAnotherBtn.disabled = false; atcAnotherBtn.textContent = 'Update cart & Design Another'; }
          });
        }
      } else {
        // Not editing, just add new
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: cartQty, properties: props })
        }).then(function(r) { return r.json(); }).then(function(data) {
          if (data.status) { showMsg(data.description || 'Could not update cart.', 'err'); }
          else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
            updateCartBadge();
            if (mode === 'goto') {
              showMsg('Added! Going to cart…', 'ok');
              setTimeout(function() { window.location.href = '/cart'; }, 800);
            } else {
              showMsg('Added to cart! Ready for another design.', 'ok');
            }
          }
        }).catch(function() { showMsg('Network error. Please try again.', 'err'); })
        .then(function() {
          if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to Cart & Go to Checkout'; }
          if (atcAnotherBtn) { atcAnotherBtn.disabled = false; atcAnotherBtn.textContent = 'Add to Cart & Design Another'; }
        });
      }
    }).catch(function() {
      showMsg('Failed to build LBRN file. Please try again.', 'err');
      if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = _editLineItemKey ? 'Update cart & Go to Checkout' : 'Add to Cart & Go to Checkout'; }
      if (atcAnotherBtn) { atcAnotherBtn.disabled = false; atcAnotherBtn.textContent = _editLineItemKey ? 'Update cart & Design Another' : 'Add to Cart & Design Another'; }
    });
  }

  if (atcBtn) atcBtn.addEventListener('click',function(){doAddToCart('goto');});
  if (atcAnotherBtn) atcAnotherBtn.addEventListener('click',function(){doAddToCart('another');});

  // ── Quantity +/- buttons ──────────────────────────────────────────────────
  (function(){
    var qInp=document.getElementById('enm-v2-qty');
    if (!qInp) return;
    // Listen for changes from Dawn's quantity-input component
    qInp.addEventListener('change',function(){updateTotalPriceDisplay();});
    qInp.addEventListener('input',function(){updateTotalPriceDisplay();});
  })();

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    var urlP=new URLSearchParams(window.location.search);
    var resumeUrl=urlP.get('resume')||'';
    var lineItemKey=urlP.get('line_item_key')||'';
    if (lineItemKey){try{sessionStorage.setItem('_enm_v2_edit_key',lineItemKey);}catch(e){}}
    _editLineItemKey=(function(){try{return sessionStorage.getItem('_enm_v2_edit_key')||'';}catch(e){return '';}})();

    if (resumeUrl||lineItemKey){
      var params=new URLSearchParams(urlP.toString()); params.delete('resume'); params.delete('line_item_key');
      history.replaceState(null,'',window.location.pathname+(params.toString()?'?'+params.toString():''));
    }

    // If the current request is not an explicit edit by line_item_key, clear edit mode.
    if (!lineItemKey) {
      try { sessionStorage.removeItem('_enm_v2_edit_key'); } catch (e) {}
      _editLineItemKey = '';
    }

    if (atcBtn) atcBtn.textContent=_editLineItemKey?'Update cart & Go to Checkout':'Add to Cart & Go to Checkout';
    if (atcAnotherBtn) atcAnotherBtn.textContent=_editLineItemKey?'Update cart & Design Another':'Add to Cart & Design Another';
    syncGridToggleUI();
    initCanvasHints();

    var nativeQtyInput=document.querySelector('.product-form form input[name="quantity"], form[action="/cart/add"] input[name="quantity"]');
    if (nativeQtyInput){
      nativeQtyInput.addEventListener('change',function(){setQty(this.value);});
    }

    buildOptionsAccordion();
    // Sync spec to the variant that options accordion defaulted to (not Dawn's stale hidden input)
    var defaultVariant=findVariantFromSelections()||(_product.variants||[])[0];
    if (defaultVariant) updateSpecFromVariant(defaultVariant.id);

    initTextLayers();
    buildLineInputs();
    buildClipartPicker();
    bindCodeControls();
    initTemplateIfAny();
    buildLayersList();
    syncCodePanel();
    if (spec.borderPng) loadBorderImage(spec.borderPng, renderCanvas);
    resizeCanvas();

    function finishInit(savedState) {
      if (savedState) { 
        applyDesignState(savedState); 
        hydrateSavedOptions(savedState);
        // Resize canvas after applying saved state (spec dimensions may have changed)
        resizeCanvas();
      }
      renderCanvas();
      var qtyFromUrl=new URLSearchParams(window.location.search).get('qty');
      if (qtyFromUrl) {
        setQty(qtyFromUrl);
      } else if (savedState && savedState.qty != null) {
        setQty(savedState.qty);
      } else {
        var nativeQty=getNativeQty();
        if (nativeQty) setQty(nativeQty);
      }
      if (savedState||_editLineItemKey) {
        // Auto-scroll to the customizer section
        setTimeout(function(){
          var root=document.getElementById('enm-v2-root');
          if (root) root.scrollIntoView({behavior:'smooth',block:'start'});
        }, 350);
      }
      if (document.fonts&&document.fonts.ready) document.fonts.ready.then(function(){renderCanvas();});
    }

    if (resumeUrl){
      fetch(resumeUrl).then(function(r){return r.json();}).then(function(s){finishInit(s);}).catch(function(){finishInit(null);});
    } else {
      finishInit(null);
    }

    // Listen for Dawn variant:change (price updates from native picker if still active)
    document.addEventListener('variant:change',function(){
      if (_suppressVariantChange) return; // fired by our own syncToNativePicker — skip
      var vid=findCurrentVariantId(); if (!vid) return;
      var prevWidth=spec.width, prevHeight=spec.height;
      updateSpecFromVariant(vid); initTextLayers(prevWidth, prevHeight); buildLineInputs(); resizeCanvas();
    });
  }

  init();
})();
